import { useState, useEffect, useCallback, useRef } from "react";

const API = process.env.REACT_APP_API_URL || "http://204.168.239.129/kanteen";

const getToken = () => localStorage.getItem("kanteen_token");
const setToken = (t) => t ? localStorage.setItem("kanteen_token", t) : localStorage.removeItem("kanteen_token");

const fetcher = async (url, opts = {}) => {
  const token = getToken();
  const res = await fetch(`${API}${url}`, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { "Authorization": `Bearer ${token}` } : {}),
    },
    ...opts,
  });
  if (res.status === 401) {
    setToken(null);
    window.location.reload();
    return;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Server error");
  return data;
};

const formatDate = (d) =>
  new Date(d + "T12:00:00").toLocaleDateString("en-US", { weekday: "long", day: "numeric", month: "long" });
const fmtPrice = (p) => `AED ${Number(p).toFixed(0)}`;
const fmtFee = (p) => `AED ${Number(p).toFixed(2)}`;
const localDateStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};
const parseSqliteUTC = (s) => s ? new Date(s.replace(' ', 'T') + 'Z') : null;

// ─── PUSH HELPERS ─────────────────────────────────────────────────────────────
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function subscribeToPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    const { publicKey } = await fetcher("/api/push/vapid-key");
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
    await fetcher("/api/push/subscribe", { method: "POST", body: JSON.stringify({ subscription: sub }) });
    return sub;
  } catch { return null; }
}

async function unsubscribeFromPush() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe();
    await fetcher("/api/push/subscribe", { method: "DELETE" });
  } catch {}
}




const AVATAR_GRADIENTS = [
  ["#667eea","#764ba2"],["#f093fb","#f5576c"],["#4facfe","#00f2fe"],
  ["#43e97b","#38f9d7"],["#fa709a","#fee140"],["#a18cd1","#fbc2eb"],
  ["#f6d365","#fda085"],["#89f7fe","#66a6ff"],["#d4fc79","#96e6a1"],
  ["#e0c3fc","#8ec5fc"],["#fccb90","#d57eeb"],["#a8edea","#fed6e3"],
  ["#5ee7df","#b490ca"],["#f5af19","#f12711"],["#43cea2","#185a9d"],
  ["#c471ed","#f64f59"],
];

function getAvatarBg(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  const [c1, c2] = AVATAR_GRADIENTS[Math.abs(h) % AVATAR_GRADIENTS.length];
  return `linear-gradient(135deg, ${c1} 0%, ${c2} 100%)`;
}

function getInitials(name = "") {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0]?.[0] || "?").toUpperCase();
}

// ─── ICON ─────────────────────────────────────────────────────────────────────
const Icon = ({ n, s = 18 }) => {
  const d = {
    order:    "M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0",
    history:  "M12 2a10 10 0 100 20A10 10 0 0012 2zM12 6v6l4 2",
    report:   "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8",
    store:    "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2zM9 22V12h6v10",
    users:    "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",
    plus:     "M12 5v14M5 12h14",
    check:    "M20 6L9 17l-5-5",
    trash:    "M3 6h18M8 6V4h8v2M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6",
    lock:     "M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2zM7 11V7a5 5 0 0110 0v4",
    logout:   "M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9",
    edit:     "M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z",
    back:     "M19 12H5M12 19l-7-7 7-7",
    key:      "M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4",
    money:    "M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6",
    farewell: "M20 12v10H4V12M22 7H2v5h20V7zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z",
    bell:     "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0",
    belloff:  "M13.73 21a2 2 0 01-3.46 0M18.63 13A17.89 17.89 0 0118 8M6.26 6.26A5.86 5.86 0 006 8c0 7-3 9-3 9h14M18 8a6 6 0 00-9.33-5M1 1l22 22",
  };
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {d[n]?.split("M").filter(Boolean).map((p, i) => <path key={i} d={"M" + p} />)}
    </svg>
  );
};

// ─── CSS ──────────────────────────────────────────────────────────────────────
const css = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --bg:#f5f0e8;--surface:#ffffff;--surface2:#f9f5ef;--border:#e8e2d6;
  --accent:#d4722a;--accent2:#e8893c;--text:#1e1b18;--text2:#7a6a58;--text3:#c0b8ac;
  --green:#2a9e68;--red:#d94f4f;--blue:#4878c8;
  --r:16px;--rs:10px;
  --shadow:0 1px 3px rgba(0,0,0,.06),0 2px 8px rgba(0,0,0,.05);
  --shadow-md:0 4px 16px rgba(0,0,0,.08),0 1px 4px rgba(0,0,0,.04);
}
body{font-family:'DM Sans',sans-serif;background:var(--bg);color:var(--text);min-height:100vh;overflow-x:hidden}

.login{min-height:100vh;display:flex;flex-direction:column;align-items:center;justify-content:center;
  background:var(--bg);padding:24px;position:relative;overflow:hidden}
.login::before{content:"";position:absolute;width:420px;height:420px;border-radius:50%;
  background:radial-gradient(circle,rgba(212,114,42,.13) 0%,transparent 70%);
  top:-80px;right:-100px;pointer-events:none}
.login::after{content:"";position:absolute;width:320px;height:320px;border-radius:50%;
  background:radial-gradient(circle,rgba(76,175,125,.08) 0%,transparent 70%);
  bottom:-60px;left:-80px;pointer-events:none}
.logo{font-family:'Playfair Display',serif;font-size:48px;font-weight:900;color:var(--accent);letter-spacing:-2px;line-height:1}
.logo-icon{font-size:42px;margin-bottom:6px;display:block;filter:drop-shadow(0 4px 12px rgba(212,114,42,.3))}
.tagline{color:var(--text2);font-size:12px;margin-bottom:32px;letter-spacing:4px;text-transform:uppercase;margin-top:6px}
.login-card{background:var(--surface);border:1px solid var(--border);border-radius:20px;padding:28px 24px;width:100%;max-width:390px;color:var(--text);box-shadow:var(--shadow-md);position:relative;z-index:1}
.login-title{font-family:'Playfair Display',serif;font-size:20px;margin-bottom:4px;color:var(--text)}
.login-sub{color:var(--text2);font-size:13px;margin-bottom:22px}
.ucard{display:flex;align-items:center;gap:12px;padding:13px 14px;border:1px solid var(--border);border-radius:12px;background:var(--surface2);cursor:pointer;text-align:left;transition:all .2s;color:var(--text);width:100%}
.ucard:hover{border-color:var(--accent);background:rgba(212,114,42,.06)}
.ucard-name{font-weight:600;font-size:14px;color:var(--text)}
.ucard-role{font-size:11px;color:var(--accent);margin-top:2px}
.login-search{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:var(--rs);padding:10px 14px 10px 36px;color:var(--text);font-family:'DM Sans',sans-serif;font-size:14px;outline:none;transition:border-color .2s;margin-bottom:12px}
.login-search:focus{border-color:var(--accent)}
.login-search::placeholder{color:var(--text3)}
.user-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;max-height:380px;overflow-y:auto;padding-right:2px}
.user-grid::-webkit-scrollbar{width:3px}
.user-grid::-webkit-scrollbar-thumb{background:var(--border);border-radius:4px}
.ugrid-card{display:flex;flex-direction:column;align-items:center;gap:7px;padding:16px 10px;border:2px solid transparent;border-radius:14px;background:var(--surface2);cursor:pointer;transition:all .2s;color:var(--text);text-align:center;box-shadow:0 1px 3px rgba(0,0,0,.05)}
.ugrid-card:hover{border-color:var(--accent);background:var(--surface);box-shadow:0 6px 18px rgba(212,114,42,.14);transform:translateY(-3px)}
.ugrid-card:active{transform:scale(.95);box-shadow:none}
.ugrid-name{font-size:13px;font-weight:600;color:var(--text);line-height:1.2;word-break:break-word;margin-top:2px}
.ugrid-role{font-size:10px;color:var(--accent);font-weight:700;letter-spacing:.5px;text-transform:uppercase}
.search-wrap{position:relative;margin-bottom:4px}
.search-icon{position:absolute;left:10px;top:50%;transform:translateY(-50%);color:var(--text3);pointer-events:none}
.pin-display{display:flex;gap:14px;justify-content:center;margin-bottom:24px}
.pin-dot{width:16px;height:16px;border-radius:50%;border:2px solid var(--border);transition:all .18s cubic-bezier(.34,1.56,.64,1)}
.pin-dot.filled{background:var(--accent);border-color:var(--accent);transform:scale(1.25);box-shadow:0 0 10px rgba(212,114,42,.35)}
@keyframes shake{0%,100%{transform:translateX(0)}15%,45%,75%{transform:translateX(-7px)}30%,60%,90%{transform:translateX(7px)}}
.pin-display.shake{animation:shake .38s ease}
.pin-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;justify-items:center}
.pin-btn{background:var(--surface);border:none;border-radius:50%;width:68px;height:68px;font-size:22px;font-weight:500;color:var(--text);cursor:pointer;transition:all .12s;font-family:'DM Sans',sans-serif;box-shadow:0 2px 8px rgba(0,0,0,.08),0 0 0 1px rgba(0,0,0,.04);display:flex;align-items:center;justify-content:center}
.pin-btn:hover:not(:disabled){background:var(--surface2);box-shadow:0 4px 14px rgba(0,0,0,.1),0 0 0 1px rgba(0,0,0,.05)}
.pin-btn:active{transform:scale(.9);box-shadow:none}
.pin-btn:disabled{opacity:.35;cursor:not-allowed}
.pin-error{color:var(--red);font-size:13px;text-align:center;margin-top:10px;min-height:18px}

.app{display:flex;flex-direction:column;min-height:100vh;max-width:480px;margin:0 auto}
.header{background:var(--surface);border-bottom:1px solid var(--border);padding:14px 18px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:50;box-shadow:0 1px 8px rgba(0,0,0,.06)}
.hbrand{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;color:var(--accent)}
.hright{display:flex;align-items:center;gap:10px}
.huser{display:flex;align-items:center;gap:8px}
.avatar{border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;color:#fff;flex-shrink:0}
.hname{font-size:13px;font-weight:500}
.hadmin{font-size:10px;color:var(--accent);font-weight:700;text-transform:uppercase;letter-spacing:1px}
.ibtn{background:none;border:none;cursor:pointer;color:var(--text2);display:flex;padding:5px;border-radius:8px;transition:all .15s}
.ibtn:hover{color:var(--text);background:var(--border)}

.content{flex:1;padding:18px;padding-bottom:88px;overflow-y:auto}

.bnav{position:fixed;bottom:0;left:50%;transform:translateX(-50%);width:100%;max-width:480px;
  background:var(--surface);border-top:1px solid var(--border);display:flex;padding:6px 0;z-index:50;box-shadow:0 -1px 8px rgba(0,0,0,.06);overflow:hidden}
.ni{flex:1;min-width:0;display:flex;flex-direction:column;align-items:center;gap:3px;padding:8px 4px;cursor:pointer;
  color:var(--text3);transition:color .2s;border:none;background:none}
.ni.active{color:var(--accent)}
.nl{font-size:9px;font-weight:600;letter-spacing:.3px;text-transform:uppercase;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;text-align:center}

.card{background:var(--surface);border:1px solid var(--border);border-radius:var(--r);padding:18px;margin-bottom:14px;box-shadow:var(--shadow)}
.ctitle{font-family:'Playfair Display',serif;font-size:18px;font-weight:700;margin-bottom:3px}
.csub{color:var(--text2);font-size:13px;margin-bottom:14px}

.sh{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}
.stitle{font-family:'Playfair Display',serif;font-size:20px;font-weight:700}

.banner{border-radius:var(--r);padding:14px 18px;margin-bottom:14px;display:flex;align-items:center;gap:10px}
.banner.open{background:rgba(76,175,125,.1);border:1px solid rgba(76,175,125,.3)}
.banner.closed{background:rgba(224,92,92,.08);border:1px solid rgba(224,92,92,.2)}
.sdot{width:9px;height:9px;border-radius:50%;flex-shrink:0}
.sdot.open{background:var(--green);box-shadow:0 0 8px var(--green);animation:pulse 2s infinite}
.sdot.closed{background:var(--red)}
@keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}
.stext{font-size:13px;font-weight:500}
.stext.open{color:var(--green)}
.stext.closed{color:var(--red)}

.rcard{background:var(--surface);border:1px solid var(--border);border-radius:var(--r);padding:18px;margin-bottom:12px;transition:border-color .2s,box-shadow .2s;box-shadow:var(--shadow)}
.rcard.clickable{cursor:pointer}
.rcard.clickable:hover{border-color:var(--accent)}
.rcard-header{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px}
.rcard-name{font-family:'Playfair Display',serif;font-size:17px;font-weight:700}
.rcard-nar{font-size:12px;color:var(--text2);margin-top:2px}
.rcard-status{display:flex;align-items:center;gap:6px}
.rcard-actions{display:flex;gap:8px;margin-top:12px;padding-top:12px;border-top:1px solid var(--border)}
.rcard-orders{margin-top:10px;font-size:12px;color:var(--text2)}

.mi{background:var(--surface);border:1px solid var(--border);border-radius:var(--rs);padding:13px 15px;
  margin-bottom:8px;cursor:pointer;transition:all .2s;display:flex;align-items:center;gap:11px;box-shadow:0 1px 2px rgba(0,0,0,.04)}
.mi:hover{border-color:var(--accent)}
.mi.sel{background:rgba(212,114,42,.08);border-color:var(--accent)}
.mcheck{width:26px;height:26px;border-radius:50%;border:2px solid var(--border);display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:all .2s;font-size:12px;font-weight:700}
.mi.sel .mcheck{background:var(--accent);border-color:var(--accent);color:#0f0e0c}
.qty-ctrl{display:flex;align-items:center;gap:2px;background:rgba(212,114,42,.12);border:1px solid rgba(212,114,42,.4);border-radius:24px;padding:2px}
.qty-btn{background:none;border:none;color:var(--accent);font-size:20px;font-weight:300;cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background .15s;line-height:1;flex-shrink:0}
.qty-btn:hover:not(:disabled){background:rgba(212,114,42,.2)}
.qty-btn:disabled{opacity:.25;cursor:not-allowed}
.qty-val{font-size:15px;font-weight:700;color:var(--accent);min-width:20px;text-align:center}
.minfo{flex:1}
.mname{font-size:14px;font-weight:500}
.mnar{font-size:12px;color:var(--text2);margin-top:1px}
.mprice{font-size:14px;font-weight:600;color:var(--accent)}

.btn{display:inline-flex;align-items:center;gap:7px;padding:11px 20px;border-radius:var(--rs);
  font-family:'DM Sans',sans-serif;font-size:14px;font-weight:600;cursor:pointer;transition:all .2s;border:none}
.btn-p{background:var(--accent);color:#0f0e0c}
.btn-p:hover{background:var(--accent2)}
.btn-d{background:rgba(224,92,92,.12);color:var(--red);border:1px solid rgba(224,92,92,.25)}
.btn-d:hover{background:rgba(224,92,92,.22)}
.btn-g{background:var(--surface2);color:var(--text2);border:1px solid var(--border)}
.btn-g:hover{color:var(--text);border-color:var(--text3)}
.btn-gr{background:rgba(76,175,125,.12);color:var(--green);border:1px solid rgba(76,175,125,.25)}
.btn-gr:hover{background:rgba(76,175,125,.22)}
.btn-sm{padding:7px 14px;font-size:13px}
.btn-full{width:100%;justify-content:center}
.btn:disabled{opacity:.4;cursor:not-allowed}

.ig{margin-bottom:12px}
.il{font-size:11px;font-weight:600;color:var(--text2);text-transform:uppercase;letter-spacing:1px;margin-bottom:5px;display:block}
.inp{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:var(--rs);
  padding:10px 13px;color:var(--text);font-family:'DM Sans',sans-serif;font-size:14px;outline:none;transition:border-color .2s}
.inp:focus{border-color:var(--accent)}
.inp-row{display:grid;grid-template-columns:1fr auto;gap:10px;align-items:end}

.total-strip{background:linear-gradient(135deg,rgba(212,114,42,.08) 0%,rgba(212,114,42,.04) 100%);border:1.5px solid rgba(212,114,42,.22);border-radius:14px;
  padding:14px 16px;display:flex;justify-content:space-between;align-items:center;margin-top:12px}
.tsl{font-size:13px;color:var(--text2);font-weight:500}
.tsa{font-size:22px;font-weight:800;color:var(--accent);letter-spacing:-.5px}

.hi{background:var(--surface);border:1px solid var(--border);border-radius:var(--rs);padding:13px 15px;margin-bottom:9px;box-shadow:0 1px 2px rgba(0,0,0,.04)}
.hdate{font-size:12px;color:var(--text2);margin-bottom:5px;text-transform:capitalize}
.hrest{font-size:11px;color:var(--accent);margin-bottom:4px;font-weight:600}
.hitems{font-size:13px;color:var(--text);margin-bottom:7px;line-height:1.4}
.htotal{font-size:14px;font-weight:700;color:var(--accent)}

.rp{background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:12px 14px;margin-bottom:8px;display:flex;align-items:center;gap:12px;box-shadow:0 1px 3px rgba(0,0,0,.05)}
.rinfo{flex:1;min-width:0}
.rname{font-size:14px;font-weight:600}
.ritems{font-size:12px;color:var(--text2);margin-top:3px;line-height:1.5;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ramount{font-size:15px;font-weight:700;color:var(--accent);white-space:nowrap;background:rgba(212,114,42,.09);padding:4px 9px;border-radius:20px}

.ai{background:var(--surface2);border:1px solid var(--border);border-radius:var(--rs);
  padding:12px 15px;margin-bottom:8px;display:flex;align-items:center;gap:10px}
.ainfo{flex:1}
.aname{font-size:14px;font-weight:500}
.anar{font-size:12px;color:var(--text2)}
.aprice{font-size:14px;font-weight:700;color:var(--accent);margin-right:6px}

.ui{background:var(--surface2);border:1px solid var(--border);border-radius:var(--rs);
  padding:13px 15px;margin-bottom:8px;display:flex;align-items:center;gap:11px}
.uinfo{flex:1}
.uname-row{display:flex;align-items:center;gap:8px}
.uname{font-size:14px;font-weight:600}
.badge{display:inline-block;padding:2px 8px;border-radius:20px;font-size:10px;font-weight:700;letter-spacing:.5px}
.badge-admin{background:rgba(212,114,42,.15);color:var(--accent)}
.badge-pin{background:rgba(92,143,224,.12);color:var(--blue);font-size:10px}
.upin{font-size:11px;color:var(--text3);margin-top:2px;font-family:monospace}



.divider{height:1px;background:var(--border);margin:14px 0}

.empty{text-align:center;padding:44px 20px;color:var(--text2)}
.empty-icon{font-size:38px;margin-bottom:10px}
.empty-t{font-size:15px;font-weight:600;color:var(--text3);margin-bottom:5px}
.empty-s{font-size:13px}

.notif{position:fixed;top:18px;left:50%;transform:translateX(-50%);background:var(--surface);
  border:1px solid var(--accent);border-radius:var(--rs);padding:11px 20px;font-size:13px;font-weight:500;
  color:var(--accent);z-index:200;animation:sd .3s ease;box-shadow:0 8px 30px rgba(0,0,0,.4);
  max-width:340px;text-align:center;white-space:normal;word-break:break-word}
@keyframes sd{from{transform:translateX(-50%) translateY(-16px);opacity:0}to{transform:translateX(-50%) translateY(0);opacity:1}}

.errbanner{background:rgba(224,92,92,.1);border:1px solid rgba(224,92,92,.25);border-radius:var(--rs);
  padding:10px 14px;font-size:13px;color:var(--red);margin-bottom:12px}

.loading{display:flex;align-items:center;justify-content:center;padding:40px;color:var(--text2);font-size:14px}

.view-header{display:flex;align-items:center;gap:12px;margin-bottom:18px}
.view-title{font-family:'Playfair Display',serif;font-size:20px;font-weight:700;flex:1}

.rst-list-item{background:var(--surface2);border:1px solid var(--border);border-radius:var(--rs);
  padding:13px 15px;margin-bottom:8px;display:flex;align-items:center;gap:10px;cursor:pointer;transition:all .2s}
.rst-list-item:hover{border-color:var(--accent);background:rgba(212,114,42,.05)}
.rst-list-item.active-rst{border-color:var(--accent);background:rgba(212,114,42,.08)}

.hint{font-size:11px;color:var(--text3);margin-top:4px}
.bell-on{color:var(--accent)!important}
.bell-off{color:var(--text3)!important}

::-webkit-scrollbar{width:4px}
::-webkit-scrollbar-thumb{background:var(--border);border-radius:4px}
`;

// ─── PIN LOGIN ────────────────────────────────────────────────────────────────
function PinLogin({ onLogin }) {
  const [userList, setUserList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  useEffect(() => {
    fetcher("/api/users/list").then(setUserList).catch(e => setError(e.message));
  }, []);

  const press = async (v) => {
    if (loading || !selected) return;
    const next = pin + v;
    setPin(next);
    setError("");
    if (next.length === 4) {
      setLoading(true);
      try {
        const user = await fetcher("/api/auth/login", { method: "POST", body: JSON.stringify({ userId: selected.id, pin: next }) });
        setToken(user.token);
        onLogin(user);
      } catch (e) {
        setError(e.message);
        setShake(true);
        setTimeout(() => { setPin(""); setShake(false); }, 420);
      } finally { setLoading(false); }
    }
  };

  const del = () => { setPin(p => p.slice(0, -1)); setError(""); };
  const back = () => { setSelected(null); setPin(""); setError(""); setSearch(""); };

  const filtered = userList.filter(u => u.name.toLowerCase().includes(search.toLowerCase()));
  const sorted = [...filtered].sort((a, b) => a.name.localeCompare(b.name));

  if (!selected) return (
    <div className="login">
      <span className="logo-icon">🍽️</span>
      <div className="logo">Kanteen</div>
      <div className="tagline">Cherish Every Bite</div>
      <div className="login-card">
        <div style={{ textAlign:"center",marginBottom:14 }}>
          <div style={{ fontSize:13,fontWeight:600,color:"var(--text2)",letterSpacing:.2 }}>Choose your name to sign in</div>
        </div>
        <div className="search-wrap">
          <span className="search-icon">
            <svg width={15} height={15} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
            </svg>
          </span>
          <input className="login-search" placeholder="Tap your name…" value={search} onChange={e => setSearch(e.target.value)} autoComplete="off" />
        </div>

        <div className="user-grid">
          {sorted.map(u => (
            <button key={u.id} className="ugrid-card" onClick={() => setSelected(u)}>
              <div className="avatar" style={{ width:46,height:46,background:getAvatarBg(u.name),fontSize:18 }}>{getInitials(u.name)}</div>
              <div className="ugrid-name">{u.name}</div>
              {u.role === "admin" && <div className="ugrid-role">Admin</div>}
            </button>
          ))}
          {sorted.length === 0 && <div style={{ gridColumn:"1/-1",textAlign:"center",color:"var(--text3)",padding:20,fontSize:13 }}>No match</div>}
        </div>

        {error && <div className="pin-error" style={{ marginTop:10 }}>{error}</div>}
      </div>
    </div>
  );

  return (
    <div className="login">
      <span className="logo-icon">🍽️</span>
      <div className="logo">Kanteen</div>
      <div className="tagline">Enter your PIN</div>
      <div className="login-card">
        <button className="ibtn" onClick={back} style={{ marginBottom:16 }}><Icon n="back" /> <span style={{ fontSize:13,fontWeight:500,marginLeft:2 }}>Change</span></button>
        <div style={{ display:"flex",flexDirection:"column",alignItems:"center",gap:8,marginBottom:20 }}>
          <div className="avatar" style={{ width:64,height:64,background:getAvatarBg(selected.name),fontSize:26,boxShadow:"0 4px 16px rgba(0,0,0,.12)" }}>{getInitials(selected.name)}</div>
          <div style={{ fontWeight:700,fontSize:17 }}>{selected.name}</div>
          <div style={{ fontSize:12,color:"var(--text2)" }}>Enter your 4-digit PIN</div>
        </div>
        <div className={`pin-display${shake ? " shake" : ""}`}>
          {[0,1,2,3].map(i => <div key={i} className={`pin-dot${pin.length > i ? " filled" : ""}`} />)}
        </div>
        <div className="pin-grid">
          {[1,2,3,4,5,6,7,8,9].map(n => (
            <button key={n} className="pin-btn" onClick={() => press(String(n))} disabled={loading || pin.length >= 4}>{n}</button>
          ))}
          <button className="pin-btn" onClick={del} style={{ color:"var(--text2)",fontSize:18 }}>⌫</button>
          <button className="pin-btn" onClick={() => press("0")} disabled={loading || pin.length >= 4}>0</button>
          <div style={{ width:68,height:68 }} />
        </div>
        {error && <div className="pin-error">{error}</div>}
      </div>
    </div>
  );
}

// ─── PIN CHANGE (first login) ─────────────────────────────────────────────────
function PinChange({ user, onDone }) {
  const [step, setStep] = useState("new"); // "new" | "confirm"
  const [newPin, setNewPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const currentPad = step === "new" ? newPin : confirmPin;
  const setCurrentPad = step === "new" ? setNewPin : setConfirmPin;

  const press = async (v) => {
    if (loading) return;
    const next = currentPad + v;
    setCurrentPad(next);
    setError("");

    if (next.length === 4) {
      if (step === "new") {
        setStep("confirm");
      } else {
        // confirm
        if (next !== newPin) {
          setError("PINs don't match, try again");
          setNewPin(""); setConfirmPin(""); setStep("new");
          return;
        }
        setLoading(true);
        try {
          await fetcher("/api/users/me/change-pin", {
            method: "POST",
            body: JSON.stringify({ currentPin: "0000", newPin }),
          });
          onDone();
        } catch (e) {
          setError(e.message);
          setNewPin(""); setConfirmPin(""); setStep("new");
        } finally { setLoading(false); }
      }
    }
  };

  const del = () => { setCurrentPad(p => p.slice(0, -1)); setError(""); };
  const display = step === "new" ? newPin : confirmPin;

  return (
    <div className="login">
      <div className="logo">🍽️ Kanteen</div>
      <div className="tagline">First Login</div>
      <div className="login-card">
        <div style={{ textAlign:"center",marginBottom:16 }}>
          <div className="avatar" style={{ width:52,height:52,background:getAvatarBg(user.name),fontSize:20,margin:"0 auto 10px" }}>{getInitials(user.name)}</div>
          <div style={{ fontWeight:600,fontSize:16 }}>Welcome, {user.name}!</div>
        </div>
        <div className="login-title">{step === "new" ? "Choose a new PIN" : "Confirm your PIN"}</div>
        <div className="login-sub">
          {step === "new" ? "Your account uses a temporary PIN — set a new one to continue" : "Enter the same PIN again to confirm"}
        </div>
        <div className="pin-display">
          {[0,1,2,3].map(i => <div key={i} className={`pin-dot${display.length > i ? " filled" : ""}`} />)}
        </div>
        <div className="pin-grid">
          {[1,2,3,4,5,6,7,8,9].map(n => (
            <button key={n} className="pin-btn" onClick={() => press(String(n))} disabled={loading || display.length >= 4}>{n}</button>
          ))}
          <button className="pin-btn" onClick={del} style={{ color:"var(--text2)" }}>⌫</button>
          <button className="pin-btn" onClick={() => press("0")} disabled={loading || display.length >= 4}>0</button>
          <button className="pin-btn" style={{ background:"transparent",border:"none" }} />
        </div>
        {error && <div className="pin-error">{error}</div>}
      </div>
    </div>
  );
}

// ─── ORDER VIEW (inside a session) ───────────────────────────────────────────
function OrderView({ session: initSession, user, onBack, notify }) {
  const [menu, setMenu] = useState([]);
  const [session, setSession] = useState(initSession);
  const [myOrders, setMyOrders] = useState({});
  const [loading, setLoading] = useState(true);
  const [adminBusy, setAdminBusy] = useState(null);
  const [notifyMsgModal, setNotifyMsgModal] = useState(false);
  const isAdmin = user.role === "admin";

  const load = useCallback(async () => {
    try {
      const [menuItems, sessionData] = await Promise.all([
        fetcher(`/api/restaurants/${session.restaurant_id}/menu`),
        fetcher(`/api/sessions/${session.id}`),
      ]);
      setMenu(menuItems);
      setSession(sessionData);
      const mine = {};
      sessionData.orders.filter(o => o.user_id === user.id).forEach(o => { mine[o.item_id] = o.quantity; });
      setMyOrders(mine);
    } catch (e) { notify(e.message); }
    setLoading(false);
  }, [session.id, session.restaurant_id, user.id]);

  useEffect(() => { load(); }, []);

  const toggle = async (itemId, delta) => {
    if (session.status !== "open") return;
    try {
      const r = await fetcher("/api/orders/toggle", {
        method: "POST",
        body: JSON.stringify({ userId: user.id, itemId, sessionId: session.id, delta }),
      });
      setMyOrders(prev => {
        if (r.quantity === 0) { const { [itemId]: _, ...rest } = prev; return rest; }
        return { ...prev, [itemId]: r.quantity };
      });
    } catch (e) { notify(e.message); }
  };

  const myItemsTotal = Object.entries(myOrders).reduce((sum, [id, qty]) => {
    const item = menu.find(m => m.id === +id);
    return sum + (item ? item.price * qty : 0);
  }, 0);

  // Merge session.orders (other users) with my live myOrders for accurate totals
  const otherOrders = (session.orders || []).filter(o => o.user_id !== user.id);
  const myOrderRows = Object.entries(myOrders).map(([itemId, qty]) => {
    const item = menu.find(m => m.id === +itemId);
    return { user_id: user.id, user_name: user.name, color: user.color, avatar: user.avatar,
             item_id: +itemId, item_name: item?.name || "", name_ar: item?.name_ar || "",
             price: item?.price || 0, quantity: qty, paid: 0 };
  });
  const allCurrentOrders = [...otherOrders, ...myOrderRows];

  // Delivery fee calculation — always uses live merged total
  const deliveryFee = session.delivery_fee || 0;
  const sessionTotalQty = allCurrentOrders.reduce((s, o) => s + o.quantity, 0);
  const feePerItem = sessionTotalQty > 0 && deliveryFee > 0 ? deliveryFee / sessionTotalQty : 0;
  const myQty = myOrderRows.reduce((a, o) => a + o.quantity, 0);
  const myDelivery = Math.floor(feePerItem * myQty * 100) / 100;
  const myTotal = parseFloat((myItemsTotal + myDelivery).toFixed(2));

  const userSummary = {};
  allCurrentOrders.forEach(o => {
    if (!userSummary[o.user_id]) userSummary[o.user_id] = { name: o.user_name, color: o.color, avatar: o.avatar, items: [], itemsTotal: 0, qty: 0 };
    userSummary[o.user_id].items.push(`${o.item_name}${o.quantity > 1 ? ` ×${o.quantity}` : ""}`);
    userSummary[o.user_id].itemsTotal += o.price * o.quantity;
    userSummary[o.user_id].qty += o.quantity;
  });
  Object.values(userSummary).forEach(u => {
    u.delivery = Math.floor(feePerItem * u.qty * 100) / 100;
    u.total = parseFloat((u.itemsTotal + u.delivery).toFixed(2));
  });

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div>
      <div className="view-header">
        <button className="ibtn" onClick={onBack}><Icon n="back" /></button>
        <div className="view-title">{session.restaurant_name}</div>
      </div>

      <div className={`banner ${session.status}`}>
        <div className={`sdot ${session.status}`} />
        <div className="stext" style={{ color: session.status === "open" ? "var(--green)" : "var(--red)" }}>
          {session.status === "open" ? "Campaign open — tap to order" : "Campaign closed"}
        </div>
      </div>

      {isAdmin && session.status === "open" && (
        <div style={{ display:"flex",gap:8,marginBottom:16,flexWrap:"wrap" }}>
          <button className="btn btn-g btn-sm" disabled={!!adminBusy}
            onClick={() => setNotifyMsgModal(true)}>
            <Icon n="bell" s={14}/> Notify Team
          </button>
        </div>
      )}

      {isAdmin && session.status !== "open" && (
        <div style={{ display:"flex",gap:8,marginBottom:16,flexWrap:"wrap" }}>
          <button className="btn btn-gr btn-sm" disabled={!!adminBusy}
            onClick={async () => {
              setAdminBusy("arrived");
              try { await fetcher(`/api/push/arrived/${session.id}`, { method:"POST" }); notify("✅ Team notified!"); }
              catch (e) { notify(e.message); }
              setAdminBusy(null);
            }}>
            {adminBusy === "arrived" ? "…" : "✅ Arrived!"}
          </button>
        </div>
      )}

      {notifyMsgModal && (
        <NotifyMsgModal
          session={session}
          onSend={async (msg) => {
            setNotifyMsgModal(false);
            setAdminBusy("notify");
            try {
              await fetcher(`/api/push/notify/${session.id}`, { method:"POST", body: JSON.stringify({ message: msg }) });
              notify("🔔 Notification sent!");
            } catch (e) { notify(e.message); }
            setAdminBusy(null);
          }}
          onClose={() => setNotifyMsgModal(false)}
        />
      )}

      {session.status === "open" && (
        <>
          <div className="stitle" style={{ marginBottom:10 }}>Menu</div>
          <div className="csub" style={{ marginBottom:12 }}>Tap an item to add it · use + / − to adjust quantity (max ×3)</div>
          {menu.map(item => {
            const qty = myOrders[item.id] || 0;
            return (
              <div key={item.id} className={`mi${qty > 0 ? " sel" : ""}`}
                onClick={qty === 0 ? () => toggle(item.id, 1) : undefined}
                style={qty > 0 ? { cursor:"default" } : {}}>
                <div className="minfo">
                  <div className="mname">{item.name}</div>
                  {item.name_ar && <div className="mnar">{item.name_ar}</div>}
                </div>
                <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                  <div className="mprice">{fmtPrice(item.price)}</div>
                  {qty === 0 ? (
                    <div style={{ width:30,height:30,borderRadius:"50%",border:"2px dashed var(--border)",display:"flex",alignItems:"center",justifyContent:"center",color:"var(--text3)" }}>
                      <Icon n="plus" s={14} />
                    </div>
                  ) : (
                    <div className="qty-ctrl" onClick={e => e.stopPropagation()}>
                      <button className="qty-btn" onClick={() => toggle(item.id, -1)}>−</button>
                      <span className="qty-val">{qty}</span>
                      <button className="qty-btn" onClick={() => toggle(item.id, 1)} disabled={qty >= 3}>+</button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
          {myQty > 0 && (
            <div style={{ marginTop:12,background:"var(--surface2)",borderRadius:14,padding:"14px 16px",border:"1px solid var(--border)" }}>
              <div style={{ fontSize:11,fontWeight:700,color:"var(--text3)",textTransform:"uppercase",letterSpacing:1,marginBottom:10 }}>Your Order</div>
              <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6 }}>
                <span style={{ fontSize:13,color:"var(--text2)" }}>Items × {myQty}</span>
                <span style={{ fontSize:13,fontWeight:600 }}>{fmtPrice(myItemsTotal)}</span>
              </div>
              {deliveryFee > 0 && (
                <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6 }}>
                  <span style={{ fontSize:13,color:"var(--text2)" }}>Delivery share</span>
                  <span style={{ fontSize:13,fontWeight:600,color:"var(--blue)" }}>+{fmtFee(myDelivery)}</span>
                </div>
              )}
              <div style={{ borderTop:"1px solid var(--border)",marginTop:8,paddingTop:10,display:"flex",justifyContent:"space-between",alignItems:"center" }}>
                <span style={{ fontSize:14,fontWeight:600 }}>Your total</span>
                <span style={{ fontSize:20,fontWeight:800,color:"var(--accent)" }}>{fmtFee(myTotal)}</span>
              </div>
            </div>
          )}
        </>
      )}

      {Object.keys(userSummary).length > 0 && (
        <div style={{ marginTop:24 }}>
          <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12 }}>
            <div className="stitle" style={{ fontSize:16 }}>All Orders</div>
            <div style={{ display:"flex",alignItems:"center",gap:6 }}>
              <span style={{ fontSize:12,color:"var(--text2)",background:"var(--surface2)",border:"1px solid var(--border)",borderRadius:20,padding:"3px 10px" }}>
                {Object.keys(userSummary).length} member{Object.keys(userSummary).length > 1 ? "s" : ""}
              </span>
              {deliveryFee > 0 && (
                <span style={{ fontSize:12,color:"var(--blue)",background:"rgba(92,143,224,.1)",border:"1px solid rgba(92,143,224,.2)",borderRadius:20,padding:"3px 10px" }}>
                  🚚 {fmtPrice(deliveryFee)}
                </span>
              )}
            </div>
          </div>
          {Object.values(userSummary).map((u, i) => (
            <div key={i} className="rp">
              <div className="avatar" style={{ width:38,height:38,background:getAvatarBg(u.name),fontSize:15,flexShrink:0 }}>{getInitials(u.name)}</div>
              <div className="rinfo">
                <div className="rname">{u.name}</div>
                <div className="ritems">{u.items.join(" · ")}</div>
              </div>
              <div style={{ display:"flex",flexDirection:"column",alignItems:"flex-end",gap:2 }}>
                <div className="ramount">{fmtFee(u.total)}</div>
                {deliveryFee > 0 && <div style={{ fontSize:10,color:"var(--blue)",whiteSpace:"nowrap" }}>incl. {fmtFee(u.delivery)} delivery</div>}
              </div>
            </div>
          ))}
          <div className="total-strip">
            <div>
              <div className="tsl">Session total</div>
              {deliveryFee > 0 && <div style={{ fontSize:11,color:"var(--blue)",marginTop:1 }}>Delivery {fmtPrice(deliveryFee)} included</div>}
            </div>
            <span className="tsa">{fmtFee(Object.values(userSummary).reduce((s,u)=>s+u.total,0))}</span>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── CAMPAIGN MODAL (admin: open/edit private campaign) ──────────────────────
function CampaignModal({ restaurantId, session, allUsers, onConfirm, onClose }) {
  // session is provided when editing access of an existing session
  const editing = !!session;
  const [isPrivate, setIsPrivate] = useState(editing ? !!session.is_private : false);
  const [selected, setSelected] = useState(() => {
    if (editing && session.allowed_users) return new Set(session.allowed_users.map(u => u.id));
    return new Set();
  });
  const [busy, setBusy] = useState(false);

  const toggle = (uid) => setSelected(prev => {
    const next = new Set(prev);
    next.has(uid) ? next.delete(uid) : next.add(uid);
    return next;
  });

  const submit = async () => {
    setBusy(true);
    await onConfirm({ isPrivate, allowedUserIds: isPrivate ? [...selected] : [] });
    setBusy(false);
  };

  const members = allUsers.filter(u => u.role !== "admin").sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.6)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:20 }}>
      <div className="card" style={{ width:"100%",maxWidth:380,margin:0 }}>
        <div className="ctitle">{editing ? "Edit Campaign Access" : "Open Campaign"}</div>

        {/* Private toggle */}
        <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"12px 0",borderBottom:"1px solid var(--border)" }}>
          <div>
            <div style={{ fontWeight:600,fontSize:14 }}>🔒 Private Campaign</div>
            <div style={{ fontSize:12,color:"var(--text2)",marginTop:2 }}>Only selected members can see and order</div>
          </div>
          <button
            onClick={() => { setIsPrivate(p => !p); if (isPrivate) setSelected(new Set()); }}
            style={{ width:44,height:24,borderRadius:12,border:"none",cursor:"pointer",
              background: isPrivate ? "var(--accent)" : "var(--border)",
              position:"relative",transition:"background .2s" }}
          >
            <span style={{ position:"absolute",top:2,left: isPrivate ? 22 : 2,width:20,height:20,
              borderRadius:"50%",background:"#fff",transition:"left .2s" }} />
          </button>
        </div>

        {/* Member picker */}
        {isPrivate && (
          <div style={{ marginTop:12 }}>
            <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8 }}>
              <div style={{ fontSize:12,color:"var(--text2)" }}>Select members ({selected.size}/{members.length})</div>
              <button onClick={() => selected.size === members.length ? setSelected(new Set()) : setSelected(new Set(members.map(u=>u.id)))}
                style={{ fontSize:12,fontWeight:600,color:"var(--accent)",background:"none",border:"none",cursor:"pointer",padding:"2px 6px" }}>
                {selected.size === members.length ? "Deselect All" : "Select All"}
              </button>
            </div>
            <div style={{ display:"flex",flexDirection:"column",gap:6,maxHeight:220,overflowY:"auto" }}>
              {members.map(u => (
                <label key={u.id} style={{ display:"flex",alignItems:"center",gap:10,padding:"8px 10px",
                  borderRadius:8,cursor:"pointer",background: selected.has(u.id) ? "rgba(92,143,224,.12)" : "var(--surface2)",
                  border: selected.has(u.id) ? "1px solid var(--accent)" : "1px solid var(--border)" }}>
                  <input type="checkbox" checked={selected.has(u.id)} onChange={() => toggle(u.id)}
                    style={{ accentColor:"var(--accent)",width:16,height:16 }} />
                  <div className="avatar" style={{ width:28,height:28,background:getAvatarBg(u.name),fontSize:12,flexShrink:0 }}>{getInitials(u.name)}</div>
                  <span style={{ fontSize:14,fontWeight:500 }}>{u.name}</span>
                </label>
              ))}
              {members.length === 0 && <div style={{ color:"var(--text2)",fontSize:13 }}>No members found</div>}
            </div>
            {isPrivate && selected.size === 0 && (
              <div style={{ fontSize:12,color:"var(--red)",marginTop:6 }}>Select at least one member</div>
            )}
          </div>
        )}

        <div style={{ display:"flex",gap:8,marginTop:16 }}>
          <button className="btn btn-p btn-sm" style={{ flex:1 }} disabled={busy || (isPrivate && selected.size===0)} onClick={submit}>
            {busy ? "…" : editing ? "Save" : "Open Campaign"}
          </button>
          <button className="btn btn-g btn-sm" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ─── ORDER TAB ────────────────────────────────────────────────────────────────
function OrderTab({ user, onEnterSession, notify }) {
  const [restaurants, setRestaurants] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);
  const [campaignModal, setCampaignModal] = useState(null); // { restaurantId } or { session } for editing
  const [editAccessSession, setEditAccessSession] = useState(null);
  const [notifyMsgModal, setNotifyMsgModal] = useState(null); // { session }

  const load = useCallback(async () => {
    try {
      const calls = [
        fetcher("/api/restaurants"),
        user.role === "admin" ? fetcher("/api/sessions/latest") : fetcher("/api/sessions/open"),
      ];
      if (user.role === "admin") calls.push(fetcher("/api/users"));
      const [rests, sess, users] = await Promise.all(calls);
      setRestaurants(rests);
      setSessions(sess);
      if (users) setAllUsers(users);
    } catch (e) { notify(e.message); }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, []);

  const openCampaign = async (restaurantId, { isPrivate = false, allowedUserIds = [] } = {}) => {
    setBusy(restaurantId);
    try {
      const session = await fetcher("/api/session/open", { method: "POST", body: JSON.stringify({ restaurantId, isPrivate, allowedUserIds, date: localDateStr() }) });
      notify("Campaign opened!");
      setSessions(prev => [...prev.filter(s => s.restaurant_id !== restaurantId), session]);
    } catch (e) { notify(e.message); }
    setCampaignModal(null);
    setBusy(null);
  };

  const saveAccess = async (sessionId, { isPrivate, allowedUserIds }) => {
    try {
      const res = await fetcher(`/api/sessions/${sessionId}/members`, { method: "PUT", body: JSON.stringify({ isPrivate, allowedUserIds }) });
      setSessions(prev => prev.map(s => s.id === sessionId ? { ...s, is_private: res.is_private, allowed_users: res.allowed_users } : s));
      notify(isPrivate ? "Campaign is now private" : "Campaign is now public");
    } catch (e) { notify(e.message); }
    setEditAccessSession(null);
  };

  const closeCampaign = async (sessionId) => {
    setBusy(sessionId);
    try {
      await fetcher("/api/session/close", { method: "POST", body: JSON.stringify({ sessionId }) });
      notify("Campaign closed");
      setSessions(prev => prev.map(s => s.id === sessionId ? { ...s, status: "closed" } : s));
    } catch (e) { notify(e.message); }
    setBusy(null);
  };

  const reopenCampaign = async (sessionId) => {
    setBusy(sessionId);
    try {
      await fetcher("/api/session/reopen", { method: "POST", body: JSON.stringify({ sessionId }) });
      notify("Campaign reopened!");
      setSessions(prev => prev.map(s => s.id === sessionId ? { ...s, status: "open" } : s));
    } catch (e) { notify(e.message); }
    setBusy(null);
  };

  if (loading) return <div className="loading">Loading…</div>;

  if (user.role === "member") {
    if (sessions.length === 0) return (
      <div>
        <div className="sh"><div className="stitle">Today's Campaigns</div></div>
        <div className="empty">
          <div className="empty-icon">🍳</div>
          <div className="empty-t">No open campaigns</div>
          <div className="empty-s">Wait for the admin to open a restaurant campaign</div>
        </div>
      </div>
    );
    return (
      <div>
        <div className="sh"><div className="stitle">Today's Campaigns</div></div>
        {sessions.map(s => (
          <div key={s.id} className="rcard clickable" onClick={() => onEnterSession(s)}>
            <div className="rcard-header">
              <div>
                <div className="rcard-name">{s.restaurant_name}</div>
                {s.restaurant_name_ar && <div className="rcard-nar">{s.restaurant_name_ar}</div>}
              </div>
              <div className="rcard-status">
                <div className="sdot open" />
                <span className="stext open" style={{ fontSize:12 }}>Open</span>
              </div>
            </div>
            <div style={{ fontSize:12,color:"var(--text2)" }}>
              {s.orders.length > 0 ? `${new Set(s.orders.map(o=>o.user_id)).size} team member${new Set(s.orders.map(o=>o.user_id)).size>1?"s":""} ordered` : "No orders yet"}
              {" · "}<span style={{ color:"var(--accent)" }}>Tap to order →</span>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Admin view
  return (
    <div>
      {campaignModal && (
        <CampaignModal
          restaurantId={campaignModal.restaurantId}
          allUsers={allUsers}
          onConfirm={({ isPrivate, allowedUserIds }) => openCampaign(campaignModal.restaurantId, { isPrivate, allowedUserIds })}
          onClose={() => setCampaignModal(null)}
        />
      )}
      {editAccessSession && (
        <CampaignModal
          session={editAccessSession}
          allUsers={allUsers}
          onConfirm={({ isPrivate, allowedUserIds }) => saveAccess(editAccessSession.id, { isPrivate, allowedUserIds })}
          onClose={() => setEditAccessSession(null)}
        />
      )}
      {notifyMsgModal && (
        <NotifyMsgModal
          session={notifyMsgModal.session || null}
          onSend={async (msg) => {
            const sid = notifyMsgModal.session?.id;
            setNotifyMsgModal(null);
            if (sid) {
              setBusy(`notify_${sid}`);
              try {
                await fetcher(`/api/push/notify/${sid}`, { method:"POST", body: JSON.stringify({ message: msg }) });
                notify("🔔 Notification sent!");
              } catch (e) { notify(e.message); }
              setBusy(null);
            } else {
              try {
                await fetcher("/api/push/broadcast", { method:"POST", body: JSON.stringify({ message: msg }) });
                notify("🔔 Notification sent!");
              } catch (e) { notify(e.message); }
            }
          }}
          onClose={() => setNotifyMsgModal(null)}
        />
      )}
      <div className="sh" style={{ display:"flex",alignItems:"center",justifyContent:"space-between" }}>
        <div className="stitle">Restaurants</div>
        <button className="btn btn-g btn-sm" style={{ marginBottom:0 }}
          onClick={() => setNotifyMsgModal({ session: null })}>
          <Icon n="bell" s={14}/> Notify Team
        </button>
      </div>
      {restaurants.length === 0 && (
        <div className="empty">
          <div className="empty-icon">🏪</div>
          <div className="empty-t">No restaurants yet</div>
          <div className="empty-s">Add restaurants from the Restaurants tab</div>
        </div>
      )}
      {restaurants.map(r => {
        const rSessions = sessions.filter(s => s.restaurant_id === r.id);
        const openSessions = rSessions.filter(s => s.status === "open");
        const closedSession = rSessions.find(s => s.status === "closed");
        const publicOpen = openSessions.find(s => !s.is_private);
        return (
          <div key={r.id} className="rcard">
            <div className="rcard-header">
              <div>
                <div className="rcard-name">{r.name}</div>
                {r.name_ar && <div className="rcard-nar">{r.name_ar}</div>}
              </div>
              <div className="rcard-status">
                {openSessions.length > 0 ? (
                  <><div className="sdot open" /><span className="stext open" style={{ fontSize:12 }}>Open</span></>
                ) : closedSession ? (
                  <><div className="sdot closed" /><span className="stext closed" style={{ fontSize:12 }}>Closed</span></>
                ) : (
                  <><div className="sdot closed" /><span className="stext closed" style={{ fontSize:12 }}>No campaign</span></>
                )}
              </div>
            </div>

            {/* Open sessions — one row per session */}
            {openSessions.map((session) => (
              <div key={session.id} style={{ borderTop:"1px solid var(--border)",paddingTop:8,marginTop:8 }}>
                <div className="rcard-orders" style={{ marginBottom:6 }}>
                  {session.is_private ? (
                    <div style={{ display:"flex",alignItems:"center",gap:6,flexWrap:"wrap",marginBottom:4 }}>
                      <span style={{ fontSize:11,background:"rgba(92,143,224,.15)",color:"var(--accent)",borderRadius:6,padding:"2px 7px",fontWeight:600 }}>🔒 Private</span>
                      {(session.allowed_users||[]).map(u => (
                        <span key={u.id} className="avatar" title={u.name} style={{ width:20,height:20,background:getAvatarBg(u.name),fontSize:9,display:"inline-flex",alignItems:"center",justifyContent:"center",borderRadius:"50%" }}>{getInitials(u.name)}</span>
                      ))}
                      <button className="ibtn" title="Edit access" onClick={e=>{e.stopPropagation();setEditAccessSession(session);}} style={{ fontSize:11,padding:"2px 6px",height:"auto" }}><Icon n="key" s={12}/></button>
                    </div>
                  ) : null}
                  {session.orders.length > 0
                    ? `${new Set(session.orders.map(o=>o.user_id)).size} member${new Set(session.orders.map(o=>o.user_id)).size>1?"s":""} ordered — ${fmtPrice(session.orders.reduce((s,o)=>s+o.price*o.quantity,0))} total`
                    : "No orders yet"}
                </div>
                <div className="rcard-actions" style={{ flexWrap:"wrap" }}>
                  <button className="btn btn-g btn-sm" onClick={() => onEnterSession(session)}>View Orders</button>
                  <button className="btn btn-g btn-sm" title="Remind the team to order" disabled={busy===`notify_${session.id}`}
                    onClick={() => setNotifyMsgModal({ session })}>
                    {busy===`notify_${session.id}` ? "…" : <><Icon n="bell" s={14}/> Notify</>}
                  </button>
                  <button className="btn btn-d btn-sm" disabled={busy===session.id} onClick={() => closeCampaign(session.id)}>
                    {busy===session.id ? "…" : "Close"}
                  </button>
                </div>
              </div>
            ))}

            {/* Latest closed session — only when nothing is open */}
            {openSessions.length === 0 && closedSession && (
              <div style={{ borderTop:"1px solid var(--border)",paddingTop:8,marginTop:8 }}>
                <div className="rcard-orders" style={{ marginBottom:6 }}>
                  {closedSession.orders.length > 0
                    ? `${new Set(closedSession.orders.map(o=>o.user_id)).size} member${new Set(closedSession.orders.map(o=>o.user_id)).size>1?"s":""} ordered — ${fmtPrice(closedSession.orders.reduce((s,o)=>s+o.price*o.quantity,0))} total`
                    : "No orders yet"}
                </div>
                <div className="rcard-actions" style={{ flexWrap:"wrap" }}>
                  <button className="btn btn-g btn-sm" onClick={() => onEnterSession(closedSession)}>View Orders</button>
                  <button className="btn btn-gr btn-sm" title="The order has arrived!" disabled={busy===`arrived_${closedSession.id}`}
                    onClick={async () => {
                      setBusy(`arrived_${closedSession.id}`);
                      try { await fetcher(`/api/push/arrived/${closedSession.id}`, { method:"POST" }); notify("✅ Team notified!"); }
                      catch (e) { notify(e.message); }
                      setBusy(null);
                    }}>
                    {busy===`arrived_${closedSession.id}` ? "…" : "✅ Arrived!"}
                  </button>
                  <button className="btn btn-gr btn-sm" disabled={busy===closedSession.id} onClick={() => reopenCampaign(closedSession.id)}>
                    {busy===closedSession.id ? "…" : "Reopen"}
                  </button>
                </div>
              </div>
            )}

            {/* Open campaign — always show unless a public one is already open */}
            {!publicOpen && (
              <div className="rcard-actions" style={{ borderTop:"1px solid var(--border)",paddingTop:8,marginTop:8 }}>
                <button className="btn btn-gr btn-sm" disabled={busy===r.id} onClick={() => setCampaignModal({ restaurantId: r.id })}>
                  {openSessions.length > 0 ? "Add Campaign" : "Open Campaign"}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ─── RESTAURANTS TAB (admin) ──────────────────────────────────────────────────
function RestaurantsTab({ notify }) {
  const [restaurants, setRestaurants] = useState([]);
  const [selected, setSelected] = useState(null);
  const [menu, setMenu] = useState([]);
  const [newName, setNewName] = useState("");
  const [newNameAr, setNewNameAr] = useState("");
  const [newFee, setNewFee] = useState("");
  const [editId, setEditId] = useState(null);
  const [editName, setEditName] = useState("");
  const [editNameAr, setEditNameAr] = useState("");
  const [editFee, setEditFee] = useState("");
  const [newItem, setNewItem] = useState({ name:"", name_ar:"", price:"" });
  const [editItemId, setEditItemId] = useState(null);
  const [editItem, setEditItem] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadRestaurants(); }, []);

  const loadRestaurants = async () => {
    try { setRestaurants(await fetcher("/api/restaurants")); } catch (e) { notify(e.message); }
    setLoading(false);
  };

  const loadMenu = async (rid) => {
    try { setMenu(await fetcher(`/api/restaurants/${rid}/menu`)); } catch (e) { notify(e.message); }
  };

  const selectRestaurant = (r) => { setSelected(r); loadMenu(r.id); };
  const back = () => { setSelected(null); setMenu([]); setEditItemId(null); };

  const addRestaurant = async () => {
    if (!newName.trim()) return;
    try {
      const r = await fetcher("/api/restaurants", { method:"POST", body: JSON.stringify({ name:newName.trim(), name_ar:newNameAr.trim(), delivery_fee: newFee ? +newFee : 0 }) });
      setRestaurants(prev => [...prev, r]);
      setNewName(""); setNewNameAr(""); setNewFee("");
      notify("Restaurant added");
    } catch (e) { notify(e.message); }
  };

  const saveEdit = async () => {
    try {
      const r = await fetcher(`/api/restaurants/${editId}`, { method:"PUT", body: JSON.stringify({ name:editName, name_ar:editNameAr, delivery_fee: editFee !== "" ? +editFee : undefined }) });
      setRestaurants(prev => prev.map(x => x.id===editId ? r : x));
      if (selected?.id === editId) setSelected(r);
      setEditId(null);
      notify("Saved");
    } catch (e) { notify(e.message); }
  };

  const deleteRestaurant = async (id) => {
    try {
      await fetcher(`/api/restaurants/${id}`, { method:"DELETE" });
      setRestaurants(prev => prev.filter(r => r.id !== id));
      notify("Restaurant removed");
    } catch (e) { notify(e.message); }
  };

  const addItem = async () => {
    if (!newItem.name.trim() || !newItem.price) return;
    try {
      const item = await fetcher(`/api/restaurants/${selected.id}/menu`, { method:"POST", body: JSON.stringify({ name:newItem.name.trim(), name_ar:newItem.name_ar.trim(), price:+newItem.price }) });
      setMenu(prev => [...prev, item]);
      setNewItem({ name:"", name_ar:"", price:"" });
      notify("Item added");
    } catch (e) { notify(e.message); }
  };

  const saveItemEdit = async () => {
    try {
      const item = await fetcher(`/api/menu/${editItemId}`, { method:"PUT", body: JSON.stringify(editItem) });
      setMenu(prev => prev.map(x => x.id===editItemId ? item : x));
      setEditItemId(null);
      notify("Saved");
    } catch (e) { notify(e.message); }
  };

  const deleteItem = async (id) => {
    try {
      await fetcher(`/api/menu/${id}`, { method:"DELETE" });
      setMenu(prev => prev.filter(x => x.id !== id));
      notify("Item removed");
    } catch (e) { notify(e.message); }
  };

  if (loading) return <div className="loading">Loading…</div>;

  // Menu management for selected restaurant
  if (selected) return (
    <div>
      <div className="view-header">
        <button className="ibtn" onClick={back}><Icon n="back" /></button>
        <div className="view-title">{selected.name}</div>
      </div>

      <div className="card">
        <div className="ctitle">Add Item</div>
        <div className="ig">
          <label className="il">Item Name</label>
          <input className="inp" placeholder="e.g. Fool" value={newItem.name} onChange={e=>setNewItem(p=>({...p,name:e.target.value}))} />
        </div>
        <div className="ig">
          <label className="il">Arabic Name</label>
          <input className="inp" placeholder="e.g. فول" value={newItem.name_ar} onChange={e=>setNewItem(p=>({...p,name_ar:e.target.value}))} dir="rtl" />
        </div>
        <div className="ig">
          <label className="il">Price (AED)</label>
          <input className="inp" type="number" placeholder="0" value={newItem.price} onChange={e=>setNewItem(p=>({...p,price:e.target.value}))} />
        </div>
        <button className="btn btn-p btn-full" onClick={addItem}><Icon n="plus" />Add Item</button>
      </div>

      <div className="sh" style={{ marginTop:4 }}>
        <div className="stitle">Menu ({menu.length})</div>
      </div>

      {menu.length === 0 && <div className="empty"><div className="empty-icon">🍽</div><div className="empty-t">No items yet</div></div>}

      {menu.map(item => editItemId === item.id ? (
        <div key={item.id} className="ai" style={{ flexDirection:"column",alignItems:"stretch",gap:8 }}>
          <input className="inp" value={editItem.name} onChange={e=>setEditItem(p=>({...p,name:e.target.value}))} placeholder="Name" />
          <input className="inp" value={editItem.name_ar||""} onChange={e=>setEditItem(p=>({...p,name_ar:e.target.value}))} placeholder="Arabic name" dir="rtl" />
          <input className="inp" type="number" value={editItem.price} onChange={e=>setEditItem(p=>({...p,price:+e.target.value}))} placeholder="Price" />
          <div style={{ display:"flex",gap:8 }}>
            <button className="btn btn-p" style={{ flex:1,justifyContent:"center" }} onClick={saveItemEdit}>Save</button>
            <button className="btn btn-g" onClick={() => setEditItemId(null)}>Cancel</button>
          </div>
        </div>
      ) : (
        <div key={item.id} className="ai">
          <div className="ainfo">
            <div className="aname">{item.name}</div>
            {item.name_ar && <div className="anar">{item.name_ar}</div>}
          </div>
          <span className="aprice">{fmtPrice(item.price)}</span>
          <button className="ibtn" onClick={() => { setEditItemId(item.id); setEditItem({name:item.name,name_ar:item.name_ar||"",price:item.price}); }}><Icon n="edit" s={16}/></button>
          <button className="ibtn" style={{ color:"var(--red)" }} onClick={() => deleteItem(item.id)}><Icon n="trash" s={16}/></button>
        </div>
      ))}
    </div>
  );

  // Restaurant list
  return (
    <div>
      <div className="sh"><div className="stitle">Restaurants</div></div>

      <div className="card">
        <div className="ctitle">Add Restaurant</div>
        <div className="ig">
          <label className="il">Name</label>
          <input className="inp" placeholder="e.g. Ful & Falafel" value={newName} onChange={e=>setNewName(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addRestaurant()} />
        </div>
        <div className="ig">
          <label className="il">Arabic Name (optional)</label>
          <input className="inp" placeholder="e.g. فول وطعمية" value={newNameAr} onChange={e=>setNewNameAr(e.target.value)} dir="rtl" />
        </div>
        <div className="ig">
          <label className="il">Delivery Fee (AED) — 0 = free</label>
          <input className="inp" type="number" min="0" placeholder="0" value={newFee} onChange={e=>setNewFee(e.target.value)} />
        </div>
        <button className="btn btn-p btn-full" onClick={addRestaurant}><Icon n="plus" />Add Restaurant</button>
      </div>

      {restaurants.length === 0 && (
        <div className="empty"><div className="empty-icon">🏪</div><div className="empty-t">No restaurants yet</div></div>
      )}

      {restaurants.map(r => editId === r.id ? (
        <div key={r.id} className="card" style={{ marginBottom:12 }}>
          <div className="ig"><label className="il">Name</label><input className="inp" value={editName} onChange={e=>setEditName(e.target.value)} /></div>
          <div className="ig"><label className="il">Arabic Name</label><input className="inp" value={editNameAr} onChange={e=>setEditNameAr(e.target.value)} dir="rtl" /></div>
          <div className="ig"><label className="il">Delivery Fee (AED)</label><input className="inp" type="number" min="0" value={editFee} onChange={e=>setEditFee(e.target.value)} /></div>
          <div style={{ display:"flex",gap:8 }}>
            <button className="btn btn-p btn-sm" onClick={saveEdit}>Save</button>
            <button className="btn btn-g btn-sm" onClick={()=>setEditId(null)}>Cancel</button>
          </div>
        </div>
      ) : (
        <div key={r.id} className="rst-list-item" onClick={() => selectRestaurant(r)}>
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:600,fontSize:14 }}>{r.name}</div>
            {r.name_ar && <div style={{ fontSize:12,color:"var(--text2)" }}>{r.name_ar}</div>}
            {r.delivery_fee > 0 && <div style={{ fontSize:11,color:"var(--blue)",marginTop:2 }}>Delivery: {fmtPrice(r.delivery_fee)}</div>}
          </div>
          <span style={{ fontSize:12,color:"var(--accent)" }}>Manage menu →</span>
          <button className="ibtn" onClick={e=>{e.stopPropagation();setEditId(r.id);setEditName(r.name);setEditNameAr(r.name_ar||"");setEditFee(r.delivery_fee||0);}}><Icon n="edit" s={16}/></button>
          <button className="ibtn" style={{ color:"var(--red)" }} onClick={e=>{e.stopPropagation();deleteRestaurant(r.id);}}><Icon n="trash" s={16}/></button>
        </div>
      ))}
    </div>
  );
}

// ─── HISTORY TAB ──────────────────────────────────────────────────────────────
function HistoryTab({ user }) {
  const [restaurantHistory, setRestaurantHistory] = useState([]);
  const [farewellHistory, setFarewellHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(null); // "restaurant" | "farewell" | null

  useEffect(() => {
    Promise.all([
      fetcher(`/api/orders/my/${user.id}`).catch(() => []),
      fetcher("/api/farewell/my").catch(() => []),
    ])
      .then(([orders, farewells]) => {
        setRestaurantHistory(orders || []);
        setFarewellHistory(farewells || []);
      })
      .finally(() => setLoading(false));
  }, [user.id]);

  const toggle = (key) => setExpanded(prev => prev === key ? null : key);

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div>
      <div className="sh"><div className="stitle">My History</div></div>

      {/* ── Restaurant card ── */}
      <div className="card" style={{ marginBottom:12, cursor:"pointer", userSelect:"none" }}
        onClick={() => toggle("restaurant")}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <span style={{ fontSize:26 }}>🍽️</span>
            <div>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:16, fontWeight:700 }}>Restaurant</div>
              <div style={{ fontSize:12, color:"var(--text2)", marginTop:2 }}>
                {restaurantHistory.length} order{restaurantHistory.length !== 1 ? "s" : ""}
              </div>
            </div>
          </div>
          <span style={{ color:"var(--text3)", fontSize:18, display:"inline-block", transition:"transform .2s",
            transform: expanded === "restaurant" ? "rotate(180deg)" : "rotate(0deg)" }}>▾</span>
        </div>

        {expanded === "restaurant" && (
          <div style={{ marginTop:14, borderTop:"1px solid var(--border)", paddingTop:12 }}
            onClick={e => e.stopPropagation()}>
            {restaurantHistory.length === 0 && (
              <div className="empty" style={{ padding:"20px 0" }}>
                <div className="empty-icon">📋</div>
                <div className="empty-t">No restaurant orders yet</div>
              </div>
            )}
            {restaurantHistory.map(h => {
              const deliveryShare = (h.session_total_qty || 0) > 0 && (h.delivery_fee || 0) > 0
                ? Math.floor(((h.delivery_fee || 0) / h.session_total_qty) * (h.user_qty || 0) * 100) / 100
                : 0;
              const total = parseFloat(((h.items_total || 0) + deliveryShare).toFixed(2));
              return (
                <div key={h.session_id} className="hi">
                  <div className="hdate">{formatDate(h.date)}</div>
                  {h.restaurant_name && <div className="hrest">{h.restaurant_name}</div>}
                  <div className="hitems">{(h.item_names || "").split("||").join(" · ")}</div>
                  {deliveryShare > 0 && (
                    <div style={{ fontSize:12, color:"var(--blue)", marginBottom:4 }}>
                      + {fmtFee(deliveryShare)} delivery ({fmtPrice(h.delivery_fee)} ÷ {h.session_total_qty} items × {h.user_qty})
                    </div>
                  )}
                  <div className="htotal">{fmtFee(total)}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ── Farewell card ── */}
      <div className="card" style={{ marginBottom:12, cursor:"pointer", userSelect:"none" }}
        onClick={() => toggle("farewell")}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <span style={{ fontSize:26 }}>👋</span>
            <div>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:16, fontWeight:700 }}>Farewell</div>
              <div style={{ fontSize:12, color:"var(--text2)", marginTop:2 }}>
                {farewellHistory.length} campaign{farewellHistory.length !== 1 ? "s" : ""}
              </div>
            </div>
          </div>
          <span style={{ color:"var(--text3)", fontSize:18, display:"inline-block", transition:"transform .2s",
            transform: expanded === "farewell" ? "rotate(180deg)" : "rotate(0deg)" }}>▾</span>
        </div>

        {expanded === "farewell" && (
          <div style={{ marginTop:14, borderTop:"1px solid var(--border)", paddingTop:12 }}
            onClick={e => e.stopPropagation()}>
            {farewellHistory.length === 0 && (
              <div className="empty" style={{ padding:"20px 0" }}>
                <div className="empty-icon">👋</div>
                <div className="empty-t">No farewell campaigns yet</div>
              </div>
            )}
            {farewellHistory.map(c => {
              const myContrib = (c.contributions || []).find(x => x.user_id === user.id);
              const totalAmt = c.total || 0;
              return (
                <div key={c.id} className="hi">
                  <div className="hdate">{c.created_at ? parseSqliteUTC(c.created_at).toLocaleDateString("en-US", { weekday:"long", day:"numeric", month:"long" }) : ""}</div>
                  <div className="hrest">👋 {c.person_name}{c.title ? ` — ${c.title}` : ""}</div>
                  <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:4 }}>
                    <div style={{ fontSize:12, color:"var(--text2)" }}>
                      {(c.contributions || []).length} contribution{(c.contributions || []).length !== 1 ? "s" : ""}
                      {" · "}
                      <span style={{ color: c.status === "open" ? "var(--green)" : "var(--text3)", fontWeight:600 }}>
                        {c.status === "open" ? "● Open" : "Closed"}
                      </span>
                    </div>
                    <div className="htotal">AED {totalAmt.toFixed(2)}</div>
                  </div>
                  {myContrib && (
                    <div style={{ fontSize:12, color:"var(--green)", marginTop:4, fontWeight:600 }}>
                      ✓ Your contribution: AED {myContrib.amount.toFixed(2)}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

// ─── PAY TOGGLE ──────────────────────────────────────────────────────────────
function PayToggle({ paid, onChange }) {
  return (
    <div onClick={onChange} title={paid ? "Mark as unpaid" : "Mark as paid"}
      style={{ display:"flex",alignItems:"center",gap:7,cursor:"pointer",userSelect:"none",padding:"4px 0" }}>
      <span style={{ fontSize:12,fontWeight:600,color:paid?"var(--green)":"var(--text3)",minWidth:52,textAlign:"right",transition:"color .2s" }}>
        {paid ? "Paid" : "Not paid"}
      </span>
      <div style={{
        width:42,height:24,borderRadius:12,flexShrink:0,
        background:paid?"var(--green)":"var(--border)",
        border:`1px solid ${paid?"var(--green)":"var(--text3)"}`,
        position:"relative",transition:"background .25s,border .25s",
      }}>
        <div style={{
          position:"absolute",top:3,
          left:paid?20:3,
          width:16,height:16,borderRadius:"50%",
          background:"#fff",
          boxShadow:"0 1px 4px rgba(0,0,0,.4)",
          transition:"left .25s",
        }}/>
      </div>
    </div>
  );
}

// ─── REPORT TAB ───────────────────────────────────────────────────────────────
// ─── CONFIRM MODAL ────────────────────────────────────────────────────────────
function NotifyMsgModal({ session, onSend, onClose }) {
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);
  const isBroadcast = !session;
  const send = async () => {
    if (isBroadcast && !msg.trim()) return;
    setSending(true);
    await onSend(msg.trim());
    setSending(false);
  };
  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:300,
      display:"flex",alignItems:"center",justifyContent:"center",padding:24 }}>
      <div className="card" style={{ width:"100%",maxWidth:380,margin:0,boxShadow:"0 20px 60px rgba(0,0,0,.3)" }}>
        <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:14 }}>
          <span style={{ fontSize:22 }}>🔔</span>
          <div style={{ fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:700 }}>Send Notification</div>
        </div>
        <div style={{ fontSize:13,color:"var(--text2)",marginBottom:14 }}>
          {isBroadcast
            ? "Send a message to all team members."
            : <>Remind the team about <strong>{session.restaurant_name}</strong></>}
        </div>
        <div style={{ marginBottom:16 }}>
          <label style={{ fontSize:12,color:"var(--text2)",display:"block",marginBottom:6 }}>
            Message {isBroadcast ? <span style={{ color:"var(--red)" }}>*</span> : "(optional)"}
          </label>
          <input
            className="inp"
            style={{ width:"100%",boxSizing:"border-box" }}
            placeholder={isBroadcast ? "e.g. Food is here, come pick it up!" : `${session.restaurant_name} — come order!`}
            value={msg}
            onChange={e => setMsg(e.target.value)}
            onKeyDown={e => { if (e.key === "Enter") send(); }}
            autoFocus
          />
        </div>
        <div style={{ display:"flex",gap:8,justifyContent:"flex-end" }}>
          <button className="btn btn-g btn-sm" onClick={onClose} disabled={sending}>Cancel</button>
          <button className="btn btn-gr btn-sm" onClick={send} disabled={sending || (isBroadcast && !msg.trim())}>
            {sending ? "…" : <><Icon n="bell" s={14}/> Send</>}
          </button>
        </div>
      </div>
    </div>
  );
}

function ConfirmModal({ title, message, confirmLabel = "Delete", onConfirm, onClose }) {
  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:300,
      display:"flex",alignItems:"center",justifyContent:"center",padding:24 }}>
      <div className="card" style={{ width:"100%",maxWidth:360,margin:0,boxShadow:"0 20px 60px rgba(0,0,0,.3)" }}>
        <div style={{ display:"flex",alignItems:"center",gap:10,marginBottom:10 }}>
          <span style={{ fontSize:22 }}>🗑</span>
          <div style={{ fontFamily:"'Playfair Display',serif",fontSize:18,fontWeight:700 }}>{title}</div>
        </div>
        <div style={{ fontSize:14,color:"var(--text2)",lineHeight:1.6,marginBottom:20 }}>{message}</div>
        <div style={{ display:"flex",gap:8,justifyContent:"flex-end" }}>
          <button className="btn btn-g btn-sm" onClick={onClose}>Cancel</button>
          <button className="btn btn-d btn-sm" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}

function ReportTab() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);
  const [payFilter, setPayFilter] = useState({}); // {sessionId: 'all'|'paid'|'unpaid'}
  const [langPref, setLangPref] = useState({}); // {sessionId: 'en'|'ar'}
  const [payments, setPayments] = useState({}); // {`${sessionId}_${userId}`: paid}
  const [deleting, setDeleting] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null); // session id to delete

  useEffect(() => {
    fetcher("/api/report/all").then(data => {
      setSessions(data);
      // Seed payment state from API data
      const pmap = {};
      data.forEach(s => {
        s.orders.forEach(o => {
          pmap[`${s.id}_${o.user_id}`] = o.paid;
        });
      });
      setPayments(pmap);
    }).catch(console.error).finally(() => setLoading(false));
  }, []);

  const deleteSession = async (id, e) => {
    e.stopPropagation();
    setConfirmDelete(id);
  };

  const confirmDeleteSession = async () => {
    const id = confirmDelete;
    setConfirmDelete(null);
    setDeleting(id);
    try {
      await fetcher(`/api/sessions/${id}`, { method: "DELETE" });
      setSessions(prev => prev.filter(s => s.id !== id));
      if (openId === id) setOpenId(null);
    } catch (err) { /* silent */ }
    setDeleting(null);
  };

  const togglePayment = async (sessionId, userId, e) => {
    e.stopPropagation();
    const key = `${sessionId}_${userId}`;
    const wasPaid = payments[key];
    setPayments(prev => ({ ...prev, [key]: wasPaid ? 0 : 1 }));
    try {
      const r = await fetcher(`/api/sessions/${sessionId}/payments/${userId}/toggle`, { method: "POST" });
      setPayments(prev => ({ ...prev, [key]: r.paid }));
    } catch {
      setPayments(prev => ({ ...prev, [key]: wasPaid })); // rollback
    }
  };

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div>
      {confirmDelete !== null && (
        <ConfirmModal
          title="Delete Report"
          message="This report will be permanently deleted and cannot be recovered."
          confirmLabel="Delete"
          onConfirm={confirmDeleteSession}
          onClose={() => setConfirmDelete(null)}
        />
      )}
      <div className="sh"><div className="stitle">All Reports</div></div>
      {sessions.length === 0 && <div className="empty"><div className="empty-icon">📊</div><div className="empty-t">No sessions yet</div></div>}
      {sessions.map(s => {
        const isExpanded = openId === s.id;
        const filter = payFilter[s.id] || "all";

        // Build per-user summary
        const userMap = {};
        s.orders.forEach(o => {
          if (!userMap[o.user_id]) userMap[o.user_id] = { name:o.user_name, color:o.color, avatar:o.avatar, items:[], itemsTotal:0, qty:0 };
          userMap[o.user_id].items.push(`${o.item_name}${o.quantity>1?` ×${o.quantity}`:""}`);
          userMap[o.user_id].itemsTotal += o.price * o.quantity;
          userMap[o.user_id].qty += o.quantity;
        });

        // Delivery fee calculation
        const deliveryFee = s.delivery_fee || 0;
        const sessionTotalQty = s.orders.reduce((t,o)=>t+o.quantity, 0);
        const feePerItem = sessionTotalQty > 0 && deliveryFee > 0 ? deliveryFee / sessionTotalQty : 0;
        Object.values(userMap).forEach(u => {
          u.delivery = Math.floor(feePerItem * u.qty * 100) / 100;
          u.total = parseFloat((u.itemsTotal + u.delivery).toFixed(2));
        });

        // Build item summary (what to order from restaurant)
        const lang = langPref[s.id] || "en";
        const itemTotals = {};
        s.orders.forEach(o => {
          const label = lang === "ar" && o.name_ar ? o.name_ar : o.item_name;
          if (!itemTotals[label]) itemTotals[label] = 0;
          itemTotals[label] += o.quantity;
        });

        const grandTotal = parseFloat(Object.values(userMap).reduce((t,u)=>t+u.total, 0).toFixed(2));
        const userList = Object.entries(userMap).map(([uid, u]) => ({
          ...u, userId: +uid,
          paid: payments[`${s.id}_${uid}`] || 0,
        }));

        const filteredUsers = userList.filter(u =>
          filter === "all" ? true : filter === "paid" ? u.paid : !u.paid
        );
        const unpaidTotal = parseFloat(userList.filter(u => !u.paid).reduce((t,u)=>t+u.total, 0).toFixed(2));

        return (
          <div key={s.id} className="card" style={{ marginBottom:12 }}>
            {/* Header — always visible */}
            <div style={{ cursor:"pointer" }} onClick={() => setOpenId(isExpanded ? null : s.id)}>
              <div className="rcard-header" style={{ marginBottom:4 }}>
                <div>
                  <div style={{ fontWeight:600,fontSize:14 }}>{formatDate(s.date)}</div>
                  {s.restaurant_name && <div style={{ fontSize:12,color:"var(--accent)",marginTop:2 }}>{s.restaurant_name}</div>}
                </div>
                <div style={{ display:"flex",alignItems:"center",gap:8 }}>
                  <span className={`badge badge-${s.status==="open"?"open":"closed"}`}>{s.status}</span>
                  <span style={{ color:"var(--accent)",fontWeight:700 }}>{fmtFee(grandTotal)}</span>
                  <button onClick={e=>deleteSession(s.id,e)} disabled={deleting===s.id}
                    style={{ background:"none",border:"none",cursor:"pointer",color:"var(--text3)",padding:"2px 4px",borderRadius:6,fontSize:14,lineHeight:1,transition:"color .15s" }}
                    title="Delete report"
                    onMouseEnter={e=>e.currentTarget.style.color="var(--red)"}
                    onMouseLeave={e=>e.currentTarget.style.color="var(--text3)"}>
                    {deleting===s.id ? "…" : "🗑"}
                  </button>
                </div>
              </div>
              <div style={{ fontSize:12,color:"var(--text2)" }}>
                {userList.length} order{userList.length!==1?"s":""} · {isExpanded ? "▲ collapse" : "▼ expand"}
              </div>
            </div>

            {isExpanded && (
              <>
                <div className="divider" />

                {/* ── ORDER SUMMARY (what to call the restaurant) ── */}
                {Object.keys(itemTotals).length > 0 && (() => {
                  const totalQtyCall = Object.values(itemTotals).reduce((a,b)=>a+b,0);
                  return (
                    <div style={{ marginBottom:16,borderRadius:14,overflow:"hidden",border:"1px solid rgba(212,114,42,.22)",boxShadow:"0 2px 8px rgba(212,114,42,.07)" }}>
                      {/* Header */}
                      <div style={{ background:"linear-gradient(135deg,rgba(212,114,42,.14) 0%,rgba(212,114,42,.07) 100%)",padding:"10px 14px",display:"flex",alignItems:"center",justifyContent:"space-between" }}>
                        <div style={{ display:"flex",alignItems:"center",gap:7 }}>
                          <span style={{ fontSize:16 }}>📞</span>
                          <div>
                            <div style={{ fontSize:12,fontWeight:700,color:"var(--accent)",letterSpacing:.3 }}>Call the restaurant</div>
                            <div style={{ fontSize:11,color:"var(--text2)",marginTop:1 }}>{totalQtyCall} item{totalQtyCall>1?"s":""} to order</div>
                          </div>
                        </div>
                        <div style={{ display:"flex",gap:4 }}>
                          {["en","ar"].map(l => (
                            <button key={l} onClick={e=>{e.stopPropagation();setLangPref(p=>({...p,[s.id]:l}))}}
                              style={{ padding:"3px 10px",borderRadius:20,border:`1px solid ${lang===l?"var(--accent)":"var(--border)"}`,background:lang===l?"var(--accent)":"transparent",color:lang===l?"#fff":"var(--text2)",fontSize:11,fontWeight:700,cursor:"pointer",transition:"all .15s" }}>
                              {l.toUpperCase()}
                            </button>
                          ))}
                        </div>
                      </div>
                      {/* Item rows */}
                      <div style={{ background:"var(--surface)" }}>
                        {Object.entries(itemTotals).map(([name, qty], idx, arr) => (
                          <div key={name} style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 14px",borderBottom: idx < arr.length-1 ? "1px solid var(--border)" : "none" }}>
                            <span style={{ fontSize:14,fontWeight:500,color:"var(--text)" }}>{name}</span>
                            <span style={{ minWidth:32,height:28,borderRadius:20,background:"var(--accent)",color:"#fff",fontSize:13,fontWeight:700,display:"flex",alignItems:"center",justifyContent:"center",padding:"0 10px" }}>×{qty}</span>
                          </div>
                        ))}
                      </div>
                      {/* Footer: delivery info */}
                      {deliveryFee > 0 && (
                        <div style={{ background:"rgba(92,143,224,.06)",borderTop:"1px solid rgba(92,143,224,.15)",padding:"8px 14px",display:"flex",alignItems:"center",gap:6 }}>
                          <span style={{ fontSize:13 }}>🚚</span>
                          <span style={{ fontSize:12,color:"var(--blue)",fontWeight:500 }}>Delivery {fmtPrice(deliveryFee)} — {fmtFee(Math.floor(feePerItem*100)/100)}/item</span>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {s.orders.length === 0 && <div style={{ color:"var(--text2)",fontSize:13 }}>No orders</div>}

                {/* ── PAYMENT FILTER (closed sessions only) ── */}
                {s.status === "closed" && userList.length > 0 && (
                  <div style={{ display:"flex",gap:6,marginBottom:12,alignItems:"center" }}>
                    <span style={{ fontSize:11,color:"var(--text2)",marginRight:4 }}>Filter:</span>
                    {["all","paid","unpaid"].map(f => (
                      <button key={f} onClick={e=>{e.stopPropagation();setPayFilter(p=>({...p,[s.id]:f}))}}
                        style={{ padding:"4px 12px",borderRadius:20,border:`1px solid ${filter===f?"var(--accent)":"var(--border)"}`,background:filter===f?"rgba(212,114,42,.15)":"transparent",color:filter===f?"var(--accent)":"var(--text2)",fontSize:12,fontWeight:600,cursor:"pointer" }}>
                        {f==="all"?"All":f==="paid"?"Paid ✓":"Unpaid"}
                        {f==="unpaid" && unpaidTotal > 0 && <span style={{ marginLeft:4,color:"var(--red)" }}>({fmtFee(unpaidTotal)})</span>}
                      </button>
                    ))}
                  </div>
                )}

                {/* ── PER-USER LIST ── */}
                {filteredUsers.map(u => (
                  <div key={u.userId} className="rp" style={{ opacity: (s.status==="closed" && u.paid) ? 0.6 : 1, transition:"opacity .2s" }}>
                    <div className="avatar" style={{ width:34,height:34,background:getAvatarBg(u.name),fontSize:13 }}>{getInitials(u.name)}</div>
                    <div className="rinfo">
                      <div className="rname">{u.name}</div>
                      <div className="ritems">
                        {u.items.join(" · ")}
                        {deliveryFee > 0 && <span style={{ color:"var(--blue)" }}> + {fmtFee(u.delivery)} delivery</span>}
                      </div>
                    </div>
                    <div style={{ display:"flex",alignItems:"center",gap:10 }}>
                      <div className="ramount">{fmtFee(u.total)}</div>
                      {s.status === "closed" && (
                        <PayToggle paid={u.paid} onChange={e => togglePayment(s.id, u.userId, e)} />
                      )}
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ─── TEAM TAB ─────────────────────────────────────────────────────────────────
function TeamTab({ notify }) {
  const [users, setUsers] = useState([]);
  const [newName, setNewName] = useState("");

  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetcher("/api/users").then(setUsers).catch(console.error).finally(() => setLoading(false));
  }, []);

  const addUser = async () => {
    if (!newName.trim()) return;
    try {
      const u = await fetcher("/api/users", { method:"POST", body: JSON.stringify({ name:newName.trim() }) });
      setUsers(prev => [...prev, u]);
      setNewName("");
      notify(`${u.name} added — PIN: 0000 (first login will prompt to change)`);
    } catch (e) { notify(e.message); }
  };

  const saveEdit = async () => {
    try {
      const u = await fetcher(`/api/users/${editId}`, { method:"PUT", body: JSON.stringify(editData) });
      setUsers(prev => prev.map(x => x.id===editId ? u : x));
      setEditId(null);
      notify("Saved");
    } catch (e) { notify(e.message); }
  };

  const deleteUser = async (id) => {
    try {
      await fetcher(`/api/users/${id}`, { method:"DELETE" });
      setUsers(prev => prev.filter(u => u.id !== id));
      notify("User removed");
    } catch (e) { notify(e.message); }
  };

  const resetPin = async (id) => {
    try {
      await fetcher(`/api/users/${id}/reset-pin`, { method:"POST" });
      setUsers(prev => prev.map(u => u.id === id ? { ...u, must_change_pin: 1 } : u));
      notify("PIN reset to 0000");
    } catch (e) { notify(e.message); }
  };

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div>
      <div className="sh"><div className="stitle">Team</div></div>

      <div className="card">
        <div className="ctitle">Add Member</div>
        <div className="ig">
          <label className="il">Name</label>
          <input className="inp" placeholder="Full name" value={newName} onChange={e=>setNewName(e.target.value)} onKeyDown={e=>e.key==="Enter"&&addUser()} />
        </div>

        <button className="btn btn-p btn-full" onClick={addUser}><Icon n="plus" />Add Member</button>
        <div className="hint" style={{ marginTop:8 }}>New members get PIN 0000 and must change it on first login.</div>
      </div>

      {[...users].sort((a, b) => a.name.localeCompare(b.name)).map(u => editId === u.id ? (
        <div key={u.id} className="card" style={{ marginBottom:10 }}>
          <div className="ig"><label className="il">Name</label>
            <input className="inp" value={editData.name||""} onChange={e=>setEditData(p=>({...p,name:e.target.value}))} />
          </div>

          <div style={{ display:"flex",gap:8 }}>
            <button className="btn btn-p btn-sm" onClick={saveEdit}>Save</button>
            <button className="btn btn-g btn-sm" onClick={()=>setEditId(null)}>Cancel</button>
          </div>
        </div>
      ) : (
        <div key={u.id} className="ui">
          <div className="avatar" style={{ width:38,height:38,background:getAvatarBg(u.name),fontSize:15 }}>{getInitials(u.name)}</div>
          <div className="uinfo">
            <div className="uname-row">
              <div className="uname">{u.name}</div>
              {u.role==="admin" && <span className="badge badge-admin">Admin</span>}
              {u.must_change_pin===1 && <span className="badge badge-pin">Temp PIN</span>}
            </div>
            <div className="upin">{u.role==="admin" ? "PIN locked" : (u.must_change_pin ? "PIN: 0000 (temporary)" : "PIN set")}</div>
          </div>
          {u.role !== "admin" && (
            <>
              <button className="ibtn" onClick={()=>{setEditId(u.id);setEditData({name:u.name});}}><Icon n="edit" s={16}/></button>
              <button className="ibtn" title="Reset PIN to 0000" onClick={()=>resetPin(u.id)}><Icon n="key" s={16}/></button>
              <button className="ibtn" style={{ color:"var(--red)" }} onClick={()=>deleteUser(u.id)}><Icon n="trash" s={16}/></button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

// ─── CHANGE PIN (profile) ─────────────────────────────────────────────────────
function ChangePinModal({ user, onClose, notify }) {
  const [cur, setCur] = useState("");
  const [step, setStep] = useState("current");
  const [newPin, setNewPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const display = step === "current" ? cur : newPin;
  const press = async (v) => {
    if (loading) return;
    const next = display + v;
    if (step === "current") {
      setCur(next);
      if (next.length === 4) setStep("new");
    } else {
      const np = newPin + v;
      setNewPin(np);
      if (np.length === 4) {
        setLoading(true);
        try {
          await fetcher("/api/users/me/change-pin", { method:"POST", body: JSON.stringify({ currentPin:cur, newPin:np }) });
          notify("PIN changed successfully");
          onClose();
        } catch (e) { setError(e.message); setCur(""); setNewPin(""); setStep("current"); }
        setLoading(false);
      }
    }
  };
  const del = () => {
    setError("");
    if (step === "current") setCur(p=>p.slice(0,-1));
    else setNewPin(p=>p.slice(0,-1));
  };

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.7)",zIndex:100,display:"flex",alignItems:"center",justifyContent:"center",padding:20 }}>
      <div className="login-card" style={{ maxWidth:340,margin:0 }}>
        <div style={{ display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16 }}>
          <div className="login-title">{step==="current"?"Current PIN":"New PIN"}</div>
          <button className="ibtn" onClick={onClose}>✕</button>
        </div>
        <div className="login-sub">{step==="current"?"Enter your current PIN":"Enter your new 4-digit PIN"}</div>
        <div className="pin-display">
          {[0,1,2,3].map(i=><div key={i} className={`pin-dot${display.length>i?" filled":""}`}/>)}
        </div>
        <div className="pin-grid">
          {[1,2,3,4,5,6,7,8,9].map(n=>(
            <button key={n} className="pin-btn" onClick={()=>press(String(n))} disabled={loading||display.length>=4}>{n}</button>
          ))}
          <button className="pin-btn" onClick={del} style={{ color:"var(--text2)" }}>⌫</button>
          <button className="pin-btn" onClick={()=>press("0")} disabled={loading||display.length>=4}>0</button>
          <button className="pin-btn" style={{ background:"transparent",border:"none" }}/>
        </div>
        {error && <div className="pin-error">{error}</div>}
      </div>
    </div>
  );
}


// ─── FAREWELL MODAL (admin creates a farewell campaign) ──────────────────────
function FarewellModal({ allUsers, onConfirm, onClose, initialData }) {
  const editing = !!initialData;
  const [personName, setPersonName] = useState(initialData?.personName || "");
  const [title, setTitle] = useState(initialData?.title || "");
  const [selected, setSelected] = useState(new Set(initialData?.memberIds || []));
  const [amountInput, setAmountInput] = useState("");
  const [amounts, setAmounts] = useState(initialData?.amounts || [50, 100, 150, 200]);
  const [busy, setBusy] = useState(false);
  const members = allUsers.filter(u => u.role !== "admin").sort((a, b) => a.name.localeCompare(b.name));

  const toggleMember = (uid) => setSelected(prev => {
    const next = new Set(prev); next.has(uid) ? next.delete(uid) : next.add(uid); return next;
  });
  const addAmount = () => {
    const v = parseFloat(amountInput);
    if (!isNaN(v) && v > 0 && !amounts.includes(v)) setAmounts(a => [...a, v].sort((x,y)=>x-y));
    setAmountInput("");
  };
  const removeAmount = (a) => setAmounts(prev => prev.filter(x => x !== a));

  const submit = async () => {
    if (!personName.trim() || selected.size === 0 || amounts.length === 0) return;
    setBusy(true);
    await onConfirm({ personName: personName.trim(), title: title.trim(), memberIds: [...selected], amounts });
    setBusy(false);
  };

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:200,display:"flex",alignItems:"center",justifyContent:"center",padding:20,overflowY:"auto" }}>
      <div className="card" style={{ width:"100%",maxWidth:400,margin:0,maxHeight:"90vh",overflowY:"auto" }}>
        <div className="ctitle" style={{ marginBottom:4 }}>{editing ? "✏️ Edit Farewell" : "👋 Create Farewell"}</div>
        <div className="csub">{editing ? "Update the farewell campaign details" : "Collect contributions for someone leaving"}</div>

        {/* Person name */}
        <div className="ig">
          <label className="il">Person leaving *</label>
          <input className="inp" placeholder="e.g. Sarah" value={personName} onChange={e=>setPersonName(e.target.value)} />
        </div>
        <div className="ig">
          <label className="il">Message (optional)</label>
          <input className="inp" placeholder="e.g. Farewell lunch for Sarah" value={title} onChange={e=>setTitle(e.target.value)} />
        </div>

        {/* Amount options */}
        <div className="ig">
          <label className="il">Amount options (AED) *</label>
          <div style={{ display:"flex",flexWrap:"wrap",gap:6,marginBottom:8 }}>
            {amounts.map(a => (
              <div key={a} style={{ display:"flex",alignItems:"center",gap:4,background:"rgba(212,114,42,.1)",border:"1px solid rgba(212,114,42,.3)",borderRadius:20,padding:"4px 10px" }}>
                <span style={{ fontSize:13,fontWeight:600,color:"var(--accent)" }}>AED {a}</span>
                <button onClick={() => removeAmount(a)} style={{ background:"none",border:"none",cursor:"pointer",color:"var(--text3)",fontSize:14,lineHeight:1,padding:0 }}>×</button>
              </div>
            ))}
          </div>
          <div style={{ display:"flex",gap:8 }}>
            <input className="inp" type="number" min="1" placeholder="Add amount…" value={amountInput}
              onChange={e=>setAmountInput(e.target.value)}
              onKeyDown={e=>e.key==="Enter"&&addAmount()} style={{ flex:1 }} />
            <button className="btn btn-g btn-sm" onClick={addAmount}>+ Add</button>
          </div>
        </div>

        {/* Member picker */}
        <div className="ig">
          <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8 }}>
            <label className="il" style={{ margin:0 }}>Invite members * ({selected.size}/{members.length})</label>
            <button onClick={() => selected.size === members.length ? setSelected(new Set()) : setSelected(new Set(members.map(u=>u.id)))}
              style={{ fontSize:12,fontWeight:600,color:"var(--accent)",background:"none",border:"none",cursor:"pointer" }}>
              {selected.size === members.length ? "Deselect All" : "Select All"}
            </button>
          </div>
          <div style={{ display:"flex",flexDirection:"column",gap:5,maxHeight:200,overflowY:"auto" }}>
            {members.map(u => (
              <label key={u.id} style={{ display:"flex",alignItems:"center",gap:10,padding:"8px 10px",borderRadius:8,cursor:"pointer",
                background: selected.has(u.id) ? "rgba(212,114,42,.1)" : "var(--surface2)",
                border: selected.has(u.id) ? "1px solid var(--accent)" : "1px solid var(--border)" }}>
                <input type="checkbox" checked={selected.has(u.id)} onChange={() => toggleMember(u.id)}
                  style={{ accentColor:"var(--accent)",width:16,height:16 }} />
                <div className="avatar" style={{ width:28,height:28,background:getAvatarBg(u.name),fontSize:12,flexShrink:0 }}>{getInitials(u.name)}</div>
                <span style={{ fontSize:14,fontWeight:500 }}>{u.name}</span>
              </label>
            ))}
          </div>
        </div>

        <div style={{ display:"flex",gap:8,marginTop:4 }}>
          <button className="btn btn-p btn-sm" style={{ flex:1 }}
            disabled={busy || !personName.trim() || selected.size===0 || amounts.length===0} onClick={submit}>
            {busy ? "…" : editing ? "Save Changes" : "Create Farewell"}
          </button>
          <button className="btn btn-g btn-sm" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

// ─── FAREWELL TAB ─────────────────────────────────────────────────────────────
function FarewellTab({ user, notify }) {
  const isAdmin = user.role === "admin";
  const [campaigns, setCampaigns] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editCampaign, setEditCampaign] = useState(null); // campaign being edited
  const [busy, setBusy] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null); // campaign id to delete

  const load = async () => {
    try {
      const endpoint = isAdmin ? "/api/farewell/latest" : "/api/farewell/open";
      const [camps, users] = await Promise.all([
        fetcher(endpoint),
        isAdmin ? fetcher("/api/users") : Promise.resolve([]),
      ]);
      setCampaigns(camps);
      if (isAdmin) setAllUsers(users);
    } catch (e) { notify(e.message); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const createFarewell = async (data) => {
    try {
      const c = await fetcher("/api/farewell", { method:"POST", body: JSON.stringify(data) });
      setCampaigns(prev => [c, ...prev]);
      setShowModal(false);
      notify("Farewell campaign created!");
    } catch (e) { notify(e.message); }
  };

  const updateFarewell = async (data) => {
    try {
      const c = await fetcher(`/api/farewell/${editCampaign.id}`, { method:"PUT", body: JSON.stringify(data) });
      setCampaigns(prev => prev.map(x => x.id === editCampaign.id ? c : x));
      setEditCampaign(null);
      notify("Farewell updated!");
    } catch (e) { notify(e.message); }
  };

  const closeFarewell = async (id) => {
    setBusy(id);
    try {
      const c = await fetcher(`/api/farewell/${id}/close`, { method:"POST" });
      setCampaigns(prev => prev.map(x => x.id === id ? c : x));
      notify("Farewell closed");
    } catch (e) { notify(e.message); }
    setBusy(null);
  };

  const reopenFarewell = async (id) => {
    setBusy(`reopen_${id}`);
    try {
      const c = await fetcher(`/api/farewell/${id}/reopen`, { method:"POST" });
      setCampaigns(prev => prev.map(x => x.id === id ? c : x));
      notify("Farewell reopened!");
    } catch (e) { notify(e.message); }
    setBusy(null);
  };

  const deleteFarewell = (id) => {
    setConfirmDelete(id);
  };

  const confirmDeleteFarewell = async () => {
    const id = confirmDelete;
    setConfirmDelete(null);
    setBusy(`del_${id}`);
    try {
      await fetcher(`/api/farewell/${id}`, { method:"DELETE" });
      setCampaigns(prev => prev.filter(x => x.id !== id));
      notify("Farewell deleted");
    } catch (e) { notify(e.message); }
    setBusy(null);
  };

  const contribute = async (id, amount) => {
    setBusy(`${id}_${amount}`);
    try {
      const c = await fetcher(`/api/farewell/${id}/contribute`, { method:"POST", body: JSON.stringify({ amount }) });
      setCampaigns(prev => prev.map(x => x.id === id ? c : x));
      notify("Contribution saved!");
    } catch (e) { notify(e.message); }
    setBusy(null);
  };

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div>
      <div className="sh">
        <div className="stitle">Farewell 👋</div>
        {isAdmin && (
          <button className="btn btn-p btn-sm" onClick={() => setShowModal(true)}>+ Create</button>
        )}
      </div>

      {campaigns.length === 0 && (
        <div className="empty">
          <div className="empty-icon">👋</div>
          <div className="empty-t">{isAdmin ? "No farewells yet" : "No farewell campaigns for you"}</div>
          <div className="empty-s">{isAdmin ? "Create one when someone is leaving" : "You'll see them here when invited"}</div>
        </div>
      )}

      {campaigns.map(c => {
        const myContrib = c.contributions.find(x => x.user_id === user.id);
        const totalContribs = isAdmin ? c.contributions.length : (c.contributorCount ?? 0);
        const totalAmt = c.total || 0;

        return (
          <div key={c.id} className="card" style={{ marginBottom:12 }}>
            {/* Header */}
            <div style={{ display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:10 }}>
              <div>
                <div style={{ fontSize:16,fontWeight:700 }}>👋 {c.person_name}</div>
                {c.title && <div style={{ fontSize:12,color:"var(--text2)",marginTop:2 }}>{c.title}</div>}
              </div>
              <span style={{ fontSize:11,fontWeight:700,padding:"3px 10px",borderRadius:20,
                background: c.status==="open" ? "rgba(42,158,104,.12)" : "rgba(0,0,0,.06)",
                color: c.status==="open" ? "var(--green)" : "var(--text3)" }}>
                {c.status === "open" ? "● Open" : "Closed"}
              </span>
            </div>

            {/* Total collected — visible to all */}
            <div style={{ background:"linear-gradient(135deg,rgba(212,114,42,.08),rgba(212,114,42,.04))",border:"1px solid rgba(212,114,42,.18)",borderRadius:12,padding:"10px 14px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center" }}>
              <div>
                <div style={{ fontSize:11,color:"var(--text2)",fontWeight:600,textTransform:"uppercase",letterSpacing:.5 }}>Collected</div>
                <div style={{ fontSize:22,fontWeight:800,color:"var(--accent)",marginTop:2 }}>AED {totalAmt.toFixed(2)}</div>
              </div>
              <div style={{ textAlign:"right" }}>
                <div style={{ fontSize:11,color:"var(--text2)" }}>{totalContribs} of {c.members.length} contributed</div>
                {isAdmin && (
                  <div style={{ display:"flex",marginTop:4,justifyContent:"flex-end" }}>
                    {c.members.slice(0,6).map(m => (
                      <div key={m.id} className="avatar" title={m.name}
                        style={{ width:24,height:24,fontSize:10,background:getAvatarBg(m.name),marginLeft:-4,border:"2px solid var(--surface)",
                          opacity: c.contributions.find(x=>x.user_id===m.id) ? 1 : 0.35 }}>{getInitials(m.name)}</div>
                    ))}
                    {c.members.length > 6 && <div style={{ fontSize:10,color:"var(--text2)",alignSelf:"center",marginLeft:4 }}>+{c.members.length-6}</div>}
                  </div>
                )}
              </div>
            </div>

            {/* Contribution breakdown — admin only */}
            {isAdmin && c.contributions.length > 0 && (
              <div style={{ marginBottom:10,borderRadius:10,overflow:"hidden",border:"1px solid var(--border)" }}>
                {c.contributions.map((x, idx, arr) => (
                  <div key={x.user_id} style={{ display:"flex",alignItems:"center",gap:8,padding:"8px 12px",background:"var(--surface)",borderBottom: idx<arr.length-1?"1px solid var(--border)":"none" }}>
                    <div className="avatar" style={{ width:28,height:28,fontSize:11,background:getAvatarBg(x.name),flexShrink:0 }}>{getInitials(x.name)}</div>
                    <div style={{ flex:1,fontSize:13,fontWeight:500 }}>{x.name}</div>
                    <div style={{ fontSize:13,fontWeight:700,color:"var(--accent)" }}>AED {x.amount.toFixed(2)}</div>
                  </div>
                ))}
              </div>
            )}

            {/* Member own contribution status */}
            {!isAdmin && myContrib && (
              <div style={{ marginBottom:10,background:"rgba(42,158,104,.08)",border:"1px solid rgba(42,158,104,.2)",borderRadius:10,padding:"8px 12px",fontSize:13,color:"var(--green)",fontWeight:600 }}>
                ✓ Your contribution: AED {myContrib.amount.toFixed(2)}
              </div>
            )}

            {/* Member: choose amount */}
            {!isAdmin && c.status === "open" && (
              <div>
                <div style={{ fontSize:12,color:"var(--text2)",marginBottom:6,fontWeight:600 }}>
                  {myContrib ? `Your contribution: AED ${myContrib.amount.toFixed(2)} — change?` : "Choose your contribution:"}
                </div>
                <div style={{ display:"flex",flexWrap:"wrap",gap:6 }}>
                  {c.amounts.map(a => {
                    const isSelected = myContrib?.amount === a;
                    const bKey = `${c.id}_${a}`;
                    return (
                      <button key={a} onClick={() => contribute(c.id, a)} disabled={!!busy}
                        style={{ padding:"7px 14px",borderRadius:20,border:`2px solid ${isSelected?"var(--accent)":"var(--border)"}`,
                          background: isSelected ? "var(--accent)" : "var(--surface2)",
                          color: isSelected ? "#fff" : "var(--text)",
                          fontSize:13,fontWeight:700,cursor:"pointer",transition:"all .15s",
                          opacity: busy ? .5 : 1 }}>
                        {busy===bKey ? "…" : `AED ${a}`}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Admin actions */}
            {isAdmin && (
              <div style={{ marginTop:10,display:"flex",gap:8,flexWrap:"wrap" }}>
                {c.status === "open" ? (
                  <button className="btn btn-d btn-sm" disabled={!!busy} onClick={() => closeFarewell(c.id)}>
                    {busy===c.id ? "…" : "Close"}
                  </button>
                ) : (
                  <button className="btn btn-gr btn-sm" disabled={!!busy} onClick={() => reopenFarewell(c.id)}>
                    {busy===`reopen_${c.id}` ? "…" : "Reopen"}
                  </button>
                )}
                <button className="btn btn-g btn-sm" disabled={!!busy} onClick={() => setEditCampaign(c)}>
                  ✏️ Edit
                </button>
                <button className="btn btn-d btn-sm" disabled={!!busy} onClick={() => deleteFarewell(c.id)}
                  style={{ marginLeft:"auto" }}>
                  {busy===`del_${c.id}` ? "…" : "🗑 Delete"}
                </button>
              </div>
            )}
          </div>
        );
      })}

      {showModal && (
        <FarewellModal allUsers={allUsers} onConfirm={createFarewell} onClose={() => setShowModal(false)} />
      )}
      {editCampaign && (
        <FarewellModal
          allUsers={allUsers}
          onConfirm={updateFarewell}
          onClose={() => setEditCampaign(null)}
          initialData={{
            personName: editCampaign.person_name,
            title: editCampaign.title || "",
            memberIds: (editCampaign.members || []).map(m => m.id),
            amounts: editCampaign.amounts || [],
          }}
        />
      )}
      {confirmDelete !== null && (
        <ConfirmModal
          title="Delete Farewell"
          message="This farewell campaign and all contributions will be permanently deleted."
          confirmLabel="Delete"
          onConfirm={confirmDeleteFarewell}
          onClose={() => setConfirmDelete(null)}
        />
      )}
    </div>
  );
}

// ─── APP SHELL ────────────────────────────────────────────────────────────────
export default function App() {
  const [user, setUser] = useState(null);
  const [forcePinChange, setForcePinChange] = useState(false);
  const [tab, setTab] = useState("order");
  const [session, setSession] = useState(null);
  const [notif, setNotif] = useState("");
  const [showPinModal, setShowPinModal] = useState(false);
  const [restoring, setRestoring] = useState(!!getToken());
  const [pushEnabled, setPushEnabled] = useState(false);
  const [pushLoading, setPushLoading] = useState(false);
  const swRegistered = useRef(false);
  const notifTimer = useRef(null);

  // Register service worker once
  useEffect(() => {
    if (swRegistered.current || !("serviceWorker" in navigator)) return;
    swRegistered.current = true;
    navigator.serviceWorker.register("/kanteen/sw.js", { scope: "/kanteen/" })
      .then(async (reg) => {
        await navigator.serviceWorker.ready;
        const sub = await reg.pushManager.getSubscription();
        setPushEnabled(!!sub && Notification.permission === "granted");
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!getToken()) { setRestoring(false); return; }
    fetcher("/api/auth/me")
      .then(u => { if (u) { setUser(u); if (u.must_change_pin) setForcePinChange(true); } })
      .catch(() => setToken(null))
      .finally(() => setRestoring(false));
  }, []);

  const togglePush = async () => {
    if (pushLoading) return;
    // Check support — specific message per missing feature
    if (!("serviceWorker" in navigator)) {
      notify("Service Worker not supported. Try Chrome or Edge.");
      return;
    }
    if (!("PushManager" in window)) {
      notify("On iPhone: open Safari → share → 'Add to Home Screen' → then reopen from the icon.");
      return;
    }
    if (!("Notification" in window)) {
      notify("Notification API unavailable. Try Chrome or Edge.");
      return;
    }
    setPushLoading(true);
    if (pushEnabled) {
      await unsubscribeFromPush();
      setPushEnabled(false);
      notify("Notifications disabled");
    } else {
      const permission = await Notification.requestPermission();
      if (permission === "denied") {
        notify("Permission denied. Enable notifications in browser settings.");
        setPushLoading(false);
        return;
      }
      if (permission !== "granted") {
        setPushLoading(false);
        return;
      }
      const sub = await subscribeToPush();
      if (sub) {
        setPushEnabled(true);
        notify("🔔 Notifications enabled!");
      } else {
        notify("Failed to enable. Ensure the app is on HTTPS.");
      }
    }
    setPushLoading(false);
  };

  const notify = useCallback((msg) => {
    if (notifTimer.current) clearTimeout(notifTimer.current);
    setNotif(msg);
    notifTimer.current = setTimeout(() => setNotif(""), 3000);
  }, []);

  const handleLogin = (u) => {
    setUser(u);
    if (u.must_change_pin) setForcePinChange(true);
  };

  const logout = () => {
    fetcher("/api/auth/logout", { method: "POST" }).catch(() => {});
    setToken(null);
    setUser(null); setSession(null); setTab("order");
  };

  if (restoring) return <><style>{css}</style><div style={{ display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",background:"var(--bg)" }}><div style={{ color:"var(--text2)",fontSize:14 }}>Loading…</div></div></>;

  if (!user) return (
    <>
      <style>{css}</style>
      <PinLogin onLogin={handleLogin} />
    </>
  );

  if (forcePinChange) return (
    <>
      <style>{css}</style>
      <PinChange user={user} onDone={() => { setForcePinChange(false); setUser(u => ({ ...u, must_change_pin: 0 })); }} />
    </>
  );

  const isAdmin = user.role === "admin";

  const NAV = isAdmin
    ? [
        { id:"order", icon:"order", label:"Campaigns" },
        { id:"farewell", icon:"farewell", label:"Farewell" },
        { id:"history", icon:"history", label:"History" },
        { id:"report", icon:"report", label:"Report" },
        { id:"restaurants", icon:"store", label:"Restaurants" },
        { id:"team", icon:"users", label:"Team" },
      ]
    : [
        { id:"order", icon:"order", label:"Campaigns" },
        { id:"farewell", icon:"farewell", label:"Farewell" },
        { id:"history", icon:"history", label:"History" },
      ];

  return (
    <>
      <style>{css}</style>
      <div className="app">
        <div className="header">
          <div className="hbrand">🍽️ Kanteen</div>
          <div className="hright">
            <div className="huser">
              <div className="avatar" style={{ width:32,height:32,background:getAvatarBg(user.name),fontSize:13 }}>{getInitials(user.name)}</div>
              <div>
                <div className="hname">{user.name}</div>
                {isAdmin && <div className="hadmin">Admin</div>}
              </div>
            </div>
            <button
              className={`ibtn ${pushEnabled ? "bell-on" : "bell-off"}`}
              title={pushEnabled ? "Notifications enabled — click to disable" : "Enable notifications"}
              onClick={togglePush}
              disabled={pushLoading}
            >
              <Icon n={pushEnabled ? "bell" : "belloff"} />
            </button>
            {!isAdmin && (
              <button className="ibtn" title="Change PIN" onClick={() => setShowPinModal(true)}><Icon n="key" /></button>
            )}
            <button className="ibtn" title="Logout" onClick={logout}><Icon n="logout" /></button>
          </div>
        </div>

        <div className="content">
          {session ? (
            <OrderView session={session} user={user} onBack={() => setSession(null)} notify={notify} />
          ) : (
            <>
              {tab === "order" && <OrderTab user={user} onEnterSession={setSession} notify={notify} />}
              {tab === "farewell" && <FarewellTab user={user} notify={notify} />}
              {tab === "history" && <HistoryTab user={user} />}
              {tab === "report" && isAdmin && <ReportTab />}
              {tab === "restaurants" && isAdmin && <RestaurantsTab notify={notify} />}
              {tab === "team" && isAdmin && <TeamTab notify={notify} />}
            </>
          )}
        </div>

        {!session && (
          <div className="bnav">
            {NAV.map(n => (
              <button key={n.id} className={`ni${tab===n.id?" active":""}`} onClick={() => setTab(n.id)}>
                <Icon n={n.icon} s={20} />
                <span className="nl">{n.label}</span>
              </button>
            ))}
          </div>
        )}

        {notif && <div className="notif">{notif}</div>}
        {showPinModal && <ChangePinModal user={user} notify={notify} onClose={() => setShowPinModal(false)} />}
      </div>
    </>
  );
}
